(function() {
    // 1. Lưu lại hàm gốc của trình duyệt
    const originalAddEventListener = EventTarget.prototype.addEventListener;

    // 2. Ghi đè hàm addEventListener
    EventTarget.prototype.addEventListener = function(type, listener, options) {
        // Nếu listener không phải là function (ví dụ object handleEvent), bỏ qua và gọi gốc
        if (typeof listener !== 'function') {
            return originalAddEventListener.call(this, type, listener, options);
        }

        // 3. Tạo một kho chứa danh sách các event đã gán trên chính element này
        if (!this._attachedEvents) {
            this._attachedEvents = {};
        }
        if (!this._attachedEvents[type]) {
            this._attachedEvents[type] = [];
        }

        // 4. KIỂM TRA TRÙNG LẶP (Dựa trên nội dung code của hàm)
        // Tại sao phải dùng toString()? 
        // Vì code cũ dùng () => {}, mỗi lần chạy nó tạo ra một function mới trong bộ nhớ.
        // So sánh tham chiếu (fn1 === fn2) sẽ luôn sai.
        // So sánh nội dung string (fn1.toString() === fn2.toString()) sẽ phát hiện được logic giống nhau.
        const listenerString = listener.toString();
        
        const isDuplicate = this._attachedEvents[type].some(existingListenerStr => {
            return existingListenerStr === listenerString;
        });

        if (isDuplicate) {
            // Nếu phát hiện trùng logic trên cùng 1 element -> CHẶN LẠI
            // console.warn(`[Interceptor] Blocked duplicate "${type}" event on:`, this); // Bật dòng này nếu muốn debug
            return; 
        }

        // 5. Nếu chưa có, lưu mã nguồn hàm vào kho và gọi hàm gốc
        this._attachedEvents[type].push(listenerString);
        return originalAddEventListener.call(this, type, listener, options);
    };

    // 6. Ghi đè hàm removeEventListener để đồng bộ danh sách _attachedEvents
    const originalRemoveEventListener = EventTarget.prototype.removeEventListener;
    EventTarget.prototype.removeEventListener = function(type, listener, options) {
        if (typeof listener !== 'function') {
            return originalRemoveEventListener.call(this, type, listener, options);
        }

        if (this._attachedEvents && this._attachedEvents[type]) {
            const listenerString = listener.toString();
            // Tìm và xóa listenerString khỏi mảng _attachedEvents[type]
            // Lưu ý: nếu có nhiều listener giống nhau (về string) nhưng addEventListener chặn rồi thì lý thuyết chỉ có 1.
            // Nhưng để an toàn cứ dùng filter hoặc splice index đầu tiên tìm thấy.
            const idx = this._attachedEvents[type].indexOf(listenerString);
            if (idx !== -1) {
                this._attachedEvents[type].splice(idx, 1);
            }
        }
        return originalRemoveEventListener.call(this, type, listener, options);
    };
})();

class AccountVouchers extends HTMLElement {
	constructor() {
		super();

		this.eventBus = window.sharedEventBus;
		this.message = new MeowcartLoyaltyMessage();
		this.spinner = new LoadingSpinner();
		this.generator = new MeowcartCustomCodeGenerator();
		this.provider = {
			hostName: meowcart.api_url,
		};
		this.loadMoreBtn = this.querySelector('.load-more-voucher');
		this.staging = 'https://' + Shopify.shop;
		this.apiEndPoint = {
			myPoints: meowcart.endpoints.mdw.myPoints,
			myProfile: meowcart.endpoints.idm.myProfile,
			verifyPin: meowcart.endpoints.idm.verifyPin,
			searchCampaigns: meowcart.endpoints.mdw.searchCampaigns,
			collectVoucher: meowcart.endpoints.mdw.collectVoucher,
			exchangePoint: meowcart.endpoints.mdw.exchangePoints,
			synchronizeCoupons: meowcart.endpoints.mdw.syncCoupons,
			getCoupons: meowcart.endpoints.mdw.getCoupons,
			discountUpdate: meowcart.endpoints.shopify.updateDiscount,
			getCustomerById: meowcart.endpoints.customer.getCustomerById
		};
		this.config = {
			lang: 'en',
			selectors: {
				vouchersListing: this.querySelector('.voucher-items'),
			},
			userData: {
				PIN: '',
			},
		};
		this.icon = {
			iconPassword: `
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2_1702)">
                        <path
                        d="M0.666504 7.99996C0.666504 7.99996 3.33317 2.66663 7.99984 2.66663C12.6665 2.66663 15.3332 7.99996 15.3332 7.99996C15.3332 7.99996 12.6665 13.3333 7.99984 13.3333C3.33317 13.3333 0.666504 7.99996 0.666504 7.99996Z"
                        stroke="#1E1E1E"
                        stroke-width="1.6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        />
                        <path
                        d="M7.99984 9.99996C9.10441 9.99996 9.99984 9.10453 9.99984 7.99996C9.99984 6.89539 9.10441 5.99996 7.99984 5.99996C6.89527 5.99996 5.99984 6.89539 5.99984 7.99996C5.99984 9.10453 6.89527 9.99996 7.99984 9.99996Z"
                        stroke="#1E1E1E"
                        stroke-width="1.6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_2_1702">
                        <rect width="16" height="16" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            `,
			iconHidePassword: `
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2_1689)">
                    <path d="M11.9598 11.96C10.8202 12.8286 9.43258 13.3099 7.99984 13.3333C3.33317 13.3333 0.666504 7.99996 0.666504 7.99996C1.49576 6.45456 2.64593 5.10436 4.03984 4.03996M6.59984 2.82663C7.05872 2.71921 7.52855 2.66552 7.99984 2.66663C12.6665 2.66663 15.3332 7.99996 15.3332 7.99996C14.9285 8.75703 14.4459 9.46978 13.8932 10.1266M9.41317 9.41329C9.23007 9.60979 9.00927 9.7674 8.76394 9.87671C8.51861 9.98602 8.25377 10.0448 7.98523 10.0495C7.71669 10.0543 7.44995 10.0049 7.20091 9.90429C6.95188 9.8037 6.72565 9.65398 6.53573 9.46406C6.34582 9.27414 6.1961 9.04792 6.09551 8.79889C5.99492 8.54985 5.94552 8.28311 5.95026 8.01457C5.955 7.74602 6.01378 7.48119 6.12309 7.23586C6.2324 6.99053 6.39001 6.76972 6.5865 6.58663M0.666504 0.666626L15.3332 15.3333" stroke="#1E1E1E" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_2_1689">
                    <rect width="16" height="16" fill="white"/>
                    </clipPath>
                    </defs>
                </svg>
            `,
			logoSvg: `
                <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24.5 48C37.7548 48 48.5 37.2548 48.5 24C48.5 10.7452 37.7548 0 24.5 0C11.2452 0 0.5 10.7452 0.5 24C0.5 37.2548 11.2452 48 24.5 48Z" fill="#FFBB33"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M22.0589 32.6697L21.0996 8.03516H27.8181L26.8589 32.6697H22.0589Z" fill="white"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M22.1475 35.0391H26.9475V39.8391H22.1475V35.0391Z" fill="white"/>
                </svg>
            `,
			greenDoneIcon: `
				<svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M24.5 48.75C37.7548 48.75 48.5 38.0048 48.5 24.75C48.5 11.4952 37.7548 0.75 24.5 0.75C11.2452 0.75 0.5 11.4952 0.5 24.75C0.5 38.0048 11.2452 48.75 24.5 48.75Z" fill="#00BA00"/>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M39.1742 18.0199L21.7814 35.4127L11.2012 24.8324L14.7367 21.2969L21.7814 28.3416L35.6387 14.4844L39.1742 18.0199Z" fill="white"/>
				</svg>
			`,
			nextIcon: `
				<svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
					<path d='M15 30L25 20L15 10' stroke='#1E1E1E' stroke-width='3.5' stroke-linecap='round' stroke-linejoin='round' />
				</svg>
			`,
			prevIcon: `
				<svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
					<path d='M25 30L15 20L25 10' stroke='#1E1E1E' stroke-width='3.5' stroke-linecap='round' stroke-linejoin='round' />
				</svg>
			`,
		};
		this.selectors = {
			typeFilters: this.querySelectorAll('[data-filter-type="list"]'),
			pointFilter: this.querySelector('[data-filter-type="checkbox"]'),
		};

		// filter voucher listing
		this.selectedUsageChannel = null;
		this.selectedCategory = null;
		this.selectedRanges = [];
		this.selectedSortBy = null;
		this.params = {};
		this.filterListVoucher = {};

		this.userData = {};
		this.currentListVoucher = {};
		this.currentVoucherData = null;
		this.pagination = {};

		this.activeModal = null;
	}

	connectedCallback() {
		this.setupConfig();
		this.setupEventListeners();
		this.init();
	}
	
	async init() {
		if (this.config.userToken) {
			if (window.location.pathname === '/pages/voucher-listing') {
				this.spinner.show();
				try {
					await Promise.all([
						this.getInfoWithLogoutCheck(),
						this.fetchUserPointsWithLogoutCheck(),
					]);
					if (window.location.pathname === '/pages/voucher-listing') {
						this.showListVouchers();
					}
					// this.handleExchangePoint();
				} catch (error) {
					console.error('Error in API calls:', error);
				} finally {
					this.spinner.hide();
				}
			}
		} else {
			// Trường hợp chưa đăng nhập
			this.spinner.show();

			try {
				await Promise.all([
					this.showListVouchers(), // Thêm API call này vào Promise.all
				]);
				this.toLoginCLick();
			} catch (error) {
				console.error('Error in API calls:', error);
			} finally {
				this.spinner.hide();
			}
		}

		// Exchange Tab handle functions + events
		this.handleExchangePointClick();
		this.handleExchangPointToCashEvents();
		this.createPagination();
		this.handleNotifyUserUpdateData();
	}

	toLoginCLick() {
		const loginBtn = document.querySelector('.to-login');
		if (loginBtn) {
			loginBtn.addEventListener('click', () => {
				sessionStorage.setItem('redirectURL', window.location.href);

				window.location.href = '/account/login';
			});
		}
	}

	handleNotifyUserUpdateData() {
		const notiUpdateProfile = document.querySelector(
			'.loyalty-notification'
		);
		const userState = this.userData?.profile?.state !== 'EARNONLY';

		if (notiUpdateProfile) {
			notiUpdateProfile.classList.toggle('hidden', userState);
		}

		this.backToAccountTab();
	}

	async showListVouchers() {
		const { totals, vouchers } = await this.getVouchers(null, 'next', { firstPage: true });

		this.updateVoucherListingTotals(totals, vouchers.length);

		if (vouchers.length > 0) {
			this.currentListVoucher = vouchers;
			this.clearVouchers(this.config.selectors.vouchersListing);
			this.appendNewVouchers(vouchers);
			const voucherItems =
				document.querySelectorAll('.voucher-card-item');
			vouchers.forEach((voucher, index) => {
				if (voucher.status !== 'active') {
					voucherItems[index].classList.add('inactive');
				}
			});

			this.updatePaginationButtons();
		} else {
			this.renderNoResultsMessage();
		}
	}

	updateVoucherListingTotals(totals, currentCount) {
		const resultsCountElement =
			document.querySelectorAll('.results-count-num');
		if (resultsCountElement) {
			resultsCountElement.forEach(resultEl => {
				resultEl.textContent = `${currentCount}/${totals}`;
			})
		}
	}
	handleExchangPointToCashEvents() {
		const useAllBtn = document.querySelector('.use-all-btn');
		const purchasePointInput = document.querySelector('.purchase-point');
		const exchangeBtn = document.querySelector('.btn-exchange');

		if (!useAllBtn || !purchasePointInput || !exchangeBtn) {
			return;
		}

		useAllBtn.addEventListener('click', this.handleUseAllClick.bind(this));
		purchasePointInput.addEventListener(
			'input',
			this.handlePurchaseInputChange.bind(this)
		);
		exchangeBtn.addEventListener(
			'click',
			this.handleExchangeClick.bind(this)
		);
	}

	async handleConfirmConvertPointsToCash() {
		const purchasePointInput =
			document.querySelector('.purchase-point').value;
		const valueToNumber = Number(purchasePointInput.replace(/\./g, ''));

		if (valueToNumber) {
			try {
				const response = await this.apiRequest(
					'POST',
					{
						point: valueToNumber,
					},
					{},
					this.apiEndPoint.exchangePoint
				);

				if (!response) {
					this.fakeClickCloseModal();
					this.renderCustomToast({
						type: 'error',
						text: `Đã xảy ra lỗi trong quá trình quy đổi điểm. Vui lòng thử lại sau!`,
						timer: 5000,
					});
				} else {
					const response =
						await this.fetchUserPointsWithLogoutCheck();
					if (response) {
						const exchangeBtn =
							document.querySelector('.btn-exchange');
						exchangeBtn.disabled = true;

						this.eventBus.emit('voucher_redeemed_loyalty');
						this.fakeClickCloseModal();
						this.renderCustomToast({
							type: 'success',
							text: `Quy đổi điểm thành công. Voucher đã được thêm vào Ví của bạn.`,
							timer: 5000,
						});
						this.handleResetInputField();
					}
				}
			} catch (error) {
				if (error?.response?.data?.error_fields.includes(956)) {
					document.dispatchEvent(new CustomEvent('loyalty:session-expired'));
					return;
				}
				console.error(error);
			}
		}
	}

	async handleExchangeClick() {
		const validatePoints = this.validatePoints();
		const userState = this.userData?.profile?.state === 'EARNONLY';
		if (validatePoints) {
			if (userState) {
				this.handleNotValidateUserData();
			} else {
				this.handleRedeemBtnClick();
			}
		}
	}

	handleUseAllClick() {
		const pointsSpan = document.querySelector('.points');
		const cashVoucherInput = document.querySelector('.cash-voucher');
		const purchasePointInput = document.querySelector('.purchase-point');

		if (!pointsSpan || !cashVoucherInput) {
			return;
		}

		try {
			const points = parseInt(pointsSpan.textContent.replace(/\./g, ''));
			if (!isNaN(points)) {
				const formattedPoints = this.formatNumber(points);
				purchasePointInput.value = formattedPoints;
				cashVoucherInput.value = formattedPoints;

				purchasePointInput.dispatchEvent(new Event('input'));
			}
		} catch (error) {
			console.error('Error processing points:', error);
		}
	}

	handlePurchaseInputChange() {
		const purchasePointInput = document.querySelector('.purchase-point');
		const cashVoucherInput = document.querySelector('.cash-voucher');

		if (!purchasePointInput || !cashVoucherInput) {
			return;
		}
		let value = purchasePointInput.value.replace(/\D/g, '');
		if (isNaN(value)) value = '';

		const formattedValue = this.formatNumber(value);
		cashVoucherInput.value = formattedValue;
		purchasePointInput.value = formattedValue;

		this.validatePoints();
	}

	handleResetInputField() {
		const purchasePointInput = document.querySelector('.purchase-point');
		const cashVoucherInput = document.querySelector('.cash-voucher');

		if (!purchasePointInput || !cashVoucherInput) {
			return;
		}

		purchasePointInput.value = '';
		cashVoucherInput.value = '';
	}

	validatePoints() {
		const pointsSpan = document.querySelector('.points');
		const purchasePointInput = document.querySelector('.purchase-point');
		const requirementError = document.querySelector('.soft-message');
		const errorMessageConvert = document.querySelector(
			'.error-message-convert'
		);
		const errorMessageOver = document.querySelector('.error-message-over');
		const errorMessageMin = document.querySelector('.error-message-min');
		const inputElement = document.querySelector('.purchase-point');
		const exchangeBtn = document.querySelector('.btn-exchange');
		if (
			!pointsSpan ||
			!purchasePointInput ||
			!requirementError ||
			!errorMessageConvert ||
			!errorMessageOver ||
			!inputElement
		) {
			return;
		}

		const enteredPoints = purchasePointInput.value.replace(/\./g, '');
		const enteredNumber = parseInt(enteredPoints);
		const currentPoints = parseInt(
			pointsSpan.textContent.replace(/\./g, '')
		);

		const isValidRange =
			enteredPoints >= 10000 && enteredPoints % 1000 === 0;
		const exceedsCurrentPoints = enteredPoints > currentPoints;

		requirementError.classList.add('hidden');
		errorMessageConvert.classList.add('hidden');
		errorMessageOver.classList.add('hidden');
		errorMessageMin.classList.add('hidden');
		inputElement.classList.remove('error-border');

		if (isNaN(enteredNumber)) {
			requirementError.classList.remove('hidden');
			exchangeBtn.disabled = true;
			return false; // Số nhập không hợp lệ (không phải là số)
		}

		if (enteredPoints < 10000) {
			inputElement.classList.add('error-border');
			errorMessageMin.classList.remove('hidden');
			exchangeBtn.disabled = true;
			return false; // Nhỏ hơn 10000
		}

		if (enteredPoints.length < 5) {
			requirementError.classList.remove('hidden');
			exchangeBtn.disabled = true;
			return false;
		}

		if (exceedsCurrentPoints) {
			inputElement.classList.add('error-border');
			errorMessageOver.classList.remove('hidden');
			exchangeBtn.disabled = true;
			return false;
		}

		if (!isValidRange && !exceedsCurrentPoints) {
			inputElement.classList.add('error-border');
			errorMessageConvert.classList.remove('hidden');
			requirementError.classList.remove('hidden');
			exchangeBtn.disabled = true;
			return false; // Không phải bội số của 10000 và không vượt quá số điểm hiện có
		}

		if (isValidRange && exceedsCurrentPoints) {
			inputElement.classList.add('error-border');
			errorMessageOver.classList.remove('hidden');
			exchangeBtn.disabled = true;
			return false; // Là bội số của 10000 nhưng vượt quá số điểm hiện có
		}

		if (!isValidRange && exceedsCurrentPoints) {
			inputElement.classList.add('error-border');
			requirementError.classList.remove('hidden');
			errorMessageOver.classList.remove('hidden');
			exchangeBtn.disabled = true;
			return false; // Không phải bội số của 10000 và vượt quá số điểm hiện có
		}

		// Nếu thỏa mãn tất cả điều kiện
		exchangeBtn.disabled = false;
		inputElement.classList.remove('error-border');
		return true;
	}

	showUserPoints() {
		const pointsElement = document.querySelectorAll(
			'.points, .expire-points .user-points'
		);
		const accountPagePointsElements = document.querySelectorAll(
			'.account-info .point'
		);
		const pointsTrackerNum = document.querySelectorAll('.points-tracker-num');

		const expiryElement = document.querySelector('.expire-points');
		const expiryDateElement = document.querySelector(
			'.expire-points .exchange-text .end-time-expired'
		);
		const currentPoints = this.userData.wallet.balances.current;


		if (pointsElement) {
			pointsElement.forEach((element) => {
				element.textContent = this.formatNumber(currentPoints);
			});
		}

		if (pointsTrackerNum) {
			pointsTrackerNum.forEach((element) => {
				element.textContent = currentPoints.toLocaleString() + ' điểm';
			});
		}

		const exchangeTextElement = document.querySelector('.exchange-text.lg.white.text-20');
		if (exchangeTextElement) {
			const target = exchangeTextElement.querySelector('.points') || exchangeTextElement;
			target.textContent = this.formatNumber(currentPoints);
		}

		if (accountPagePointsElements) {
			accountPagePointsElements.forEach((pointElement) => {
				pointElement.textContent = `${currentPoints.toLocaleString()} điểm`;
			});
		}

		// if (accountPagePointsElements) {
		// 	accountPagePointsElements.forEach((pointElement) => {
		// 		pointElement.innerHTML += `${currentPoints.toLocaleString()} điểm`;
		// 	});
		// }
		// if (this.userData.wallet.expires.length > 0) {
		// 	const expireDates = this.userData.wallet.expires;
	
		// 	if (expiryElement && Number(currentPoints) > 0) {
		// 		expiryElement.classList.remove('hidden');
		// 		expireDates.forEach((expireDate)=>{
		// 			expiryDateElement.textContent += this.formatDate(expireDate);
		// 		})
		// 	}
		// }

		let expiredContainer = document.querySelector(".expired-point-container-voucher");
		let expires = this.userData.wallet.expires;
		if (expiredContainer) {
			if (expires?.length > 0) {
				expiredContainer.innerHTML = "";
	
				expires.forEach(expire => {
					let expireDate = new Date(expire.validTo);
					let formattedDate = expireDate.toLocaleDateString('vi-VN');
	
					let expireItem = document.createElement("div");
					
					expireItem.classList.add("expired-point");
					expireItem.classList.add("custom-expired-point");
					expireItem.innerHTML = `
						<span class="point custom-point" data-t1-text="expired-point">${expire.points.toLocaleString()}</span> 
						<span class="custom-point-text">điểm sẽ hết hạn vào</span>
						<span class="date custom-point-text" data-t1-text="expired-date">${formattedDate}</span>
					`;
					
					expiredContainer.appendChild(expireItem);
				});
				
				expiredContainer.style.display = "block";
			} else {
				expiredContainer.style.display = "none";
			}
		}
	}

	formatNumber(number) {
		if (number === null || number === undefined) {
			return null;
		}

		return new Intl.NumberFormat('vi-VN').format(number);
	}

	handleExchangePointClick() {
		const targetElements = document.querySelectorAll(
			'[data-button="exchangePoint"]'
		);

		if (targetElements) {
			for (const element of targetElements) {
				element.addEventListener('click', () => {
					this.navigateToCashVoucherPage();
				});
			}
		}
	}

	activateExchangePointTab(tabId) {
		const tabs = this.querySelectorAll('.page-voucher-listing_tabs_title');
		const tabContents = this.querySelectorAll(
			'#voucherListing, #exchangePoint'
		);

		tabs.forEach((tab) => tab.classList.remove('active'));
		tabContents.forEach((content) => content.classList.remove('active'));

		const targetTab = this.querySelector(
			`.page-voucher-listing_tabs_title[data-target="${tabId}"]`
		);
		const targetContent = this.querySelector(`#${tabId}`);

		if (targetTab) targetTab.classList.add('active');
		if (targetContent) targetContent.classList.add('active');

		const currentUrl = new URL(window.location);
		currentUrl.searchParams.set('activeTab', tabId);
		window.history.replaceState(null, '', currentUrl.toString());
	}

	navigateToCashVoucherPage() {
		const url = `${this.staging}/pages/voucher-listing?activeTab=exchangePoint`;
		window.location.href = url;
	}

	handleReloadError() {
		const urlParams = new URLSearchParams(window.location.search);
		let reloadCount = parseInt(urlParams.get('reloadCount') || 0);
		reloadCount++;

		if (reloadCount <= 2) {
			urlParams.set('reloadCount', reloadCount);
			const newUrl = `${
				window.location.pathname
			}?${urlParams.toString()}`;
			setTimeout(() => {
				window.location.href = newUrl;
			}, 2000);
		} else {
			urlParams.delete('reloadCount');
			const newUrl = `${
				window.location.pathname
			}?${urlParams.toString()}`;
			window.history.replaceState({}, '', newUrl);
			this.showLoginRequiredSpinner();
		}
	}

	async fetchUserPointsWithRetry(retryCount = 2, retryDelay = 2000) {
		try {
			await this.fetchUserPoints();
			sessionStorage.removeItem('reloadCount'); // Xóa trạng thái nếu thành công
		} catch (error) {
			if (error?.response?.status === 401) {
				this.showLoginRequiredSpinner();
			} else if (
				error?.response?.status === 400 ||
				error?.response?.status === 999
			) {
				if (retryCount > 0) {
					// Retry với độ trễ
					await this.sleep(retryDelay);
					return this.fetchUserPointsWithRetry(
						retryCount - 1,
						retryDelay
					);
				} else {
					this.showLoginRequiredSpinner(); // Thông báo lỗi sau khi hết retry
				}
			} else {
				throw error; // Re-throw nếu lỗi không xử lý được
			}
		}
	}

	// Hàm sleep để tạo độ trễ
	sleep(ms) {
		return new Promise((resolve) => setTimeout(resolve, ms));
	}

	async fetchUserPointsWithLogoutCheck() {
		try {
			const response = await this.fetchUserPoints();
			if (response.success) {
				this.showUserPoints();
				sessionStorage.removeItem('reloadCount');
				return true;
			} else {
				if (response?.error?.code === 401) {
					this.showLoginRequiredSpinner();
				} else if (
					response?.error?.code === 400 ||
					response?.error?.code === 999
				) {
					this.handleReloadError();
				} else {
					console.log(response?.error);
				}
				return false;
			}
		} catch (error) {
			if (error.response && error.response.status === 401) {
				this.showLoginRequiredSpinner();
			} else if (error.response && error.response.status === 400) {
				window.location.reload();
			} else {
				throw error; // Re-throw other errors
			}

			return false;
		}
	}

	async getInfoWithLogoutCheck() {
		try {
			const response = await this.getInfo();

			if (!response.success) {
				if (response?.error?.code === 401) {
					this.showLoginRequiredSpinner();
					sessionStorage.removeItem('reloadCount');
				} else if (
					response?.error?.code === 400 ||
					response?.error?.code === 999
				) {
					this.handleReloadError();
				} else {
					console.log(response?.error);
				}
			}
		} catch (error) {
			if (error.response && error.response.status === 401) {
				this.showLoginRequiredSpinner();
			} else if (error.response && error.response.status === 400) {
				window.location.reload();
			} else {
				throw error; // Re-throw other errors
			}
		}
	}

	showLoginRequiredSpinner() {
		setTimeout(async () => {
			this.spinner.hide();
			localStorage.setItem('isCheckedRedirect', 'true');
			try {
				await this.removeAllDiscounts();
			} catch (e) {
				console.error('Error clearing discounts during auto-logout:', e);
			}
			fetch('/account/logout')
				.then((response) => {
					return response;
				})
				.then(() => {
					window.location.href = '/account/login?showAlert=true'; // Chuyển hướng sau khi logout thành công
					localStorage.removeItem('isLogin');
					localStorage.removeItem('loyalty_last_verified_at');
				});
		}, 1000);
	}

	async removeAllDiscounts() {
		try {
			this.spinner.show();
			const cartData = await fetch('/cart.js').then((response) =>
				response.json()
			);
			
			let url = this.provider.hostName + this.apiEndPoint.discountUpdate;
			if (url.includes("/the1/shopify")) {
				url = url.replace("/the1/shopify", "/shopify");
			}

			await fetch(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					cartId: cartData.token,
					discountCodes: [''],
				}),
			});
		} catch (error) {
			console.error('Error removing all discounts:', error);
		} finally {
			this.spinner.hide();
		}
	}

	// get metafields access token
	setupConfig() {
		const mainAccount = this.closest('main-account');
		this.config.userToken = mainAccount
			? mainAccount.config.userToken
			: this.getAttribute('data-x-user-token');
		this.config.lang = this.getAttribute('data-lang') || this.config.lang;
	}
	// event listeners for filter
	setupEventListeners() {
		this.handleTitleClick();
		this.handleClickOutside();
		this.setupFilterButtons();
		this.setupPointFilterCheckboxListener();
		this.setupVoucherTitleEvents();
		this.handleTabContentClick();
		this.setupGlobalListeners();
		this.handleNavigate();
		this.handleUserUpdateProfile();
		window.addEventListener('resize', this.handleShowFilter);
	}

	handleUserUpdateProfile() {
		document.addEventListener('profile-updated', (event) => {
			const profile = event.detail;
			this.userData.profile = profile.data;
		});

		document.addEventListener('points-updated', (event) => {
			const userPoints = event.detail;
			this.userData.wallet = userPoints;
		});
	}

	handleNavigate() {
		const loginLink = this.querySelector('#exchangePoint .black-button');

		if (loginLink) {
			loginLink.addEventListener('click', () => {
				sessionStorage.setItem('redirectURL', window.location.href);
			});
		}
	}

	handleTabContentClick() {
		const tabs = this.querySelectorAll('.page-voucher-listing_tabs_title');
		const tabContents = this.querySelectorAll(
			'#voucherListing, #exchangePoint'
		);

		if (!tabs || !tabContents) {
			return;
		}

		const activateTab = (tab) => {
			const targetTabContentId = tab.dataset.target;

			tabContents.forEach((content) =>
				content.classList.remove('active')
			);
			tabs.forEach((t) => t.classList.remove('active'));

			const targetTabContent = this.querySelector(
				`#${targetTabContentId}`
			);
			if (targetTabContent) {
				targetTabContent.classList.add('active');
			}

			tab.classList.add('active');
			if (targetTabContentId === 'voucherListing') {
				this.showListVouchers();
			}
			const element = document.getElementsByClassName('page-voucher-listing')[0];

			if (element) {
				if (element.classList.contains('voucherListing')) {
					element.classList.remove('voucherListing');
				} else {
					if (targetTabContentId !== 'voucherListing') {
						element.classList.add(targetTabContentId);
					} else {
						element.classList.remove('exchangePoint');
					}
				}
			}
			const currentUrl = new URL(window.location);
			currentUrl.searchParams.set('activeTab', targetTabContentId);
			window.history.replaceState(null, '', currentUrl.toString());
		};

		tabs.forEach((tab) => {
			tab.addEventListener('click', (event) => {
        
				event.preventDefault(); // Prevent default scroll
				activateTab(tab);
			});
		});

		const params = new URLSearchParams(window.location.search);
		const activeTabId = params.get('activeTab');
		const page_voucher_listing = document.getElementsByClassName('page-voucher-listing');
		
		if (page_voucher_listing.length > 0) {
			page_voucher_listing[0].classList.add(activeTabId);
		}

		if (activeTabId) {
			const activeTab = this.querySelector(
				`.page-voucher-listing_tabs_title[data-target="${activeTabId}"]`
			);
			if (activeTab) {
				activateTab(activeTab);
			}
		} else {
			const defaultTab = tabs[0];
			if (defaultTab) {
				activateTab(defaultTab);
			}
		}
	}

	// filter by li tag id and apply button in checkbox
	setupFilterButtons() {
		const filterActions = {
			usageChannel: {
				onlineButton: 'Online',
				storeButton: 'At Store',
				removeButton: '',
			},
			categories: {
				// food_beverage: 'food & beverage',
				// grocery: 'grocery',
				// kit_tableware: 'kitchen & tableware',
				// health_beauty: 'health & beauty',
				// fashion_lifestyle: 'fashion & lifestyle',
				// sports: 'sports',
				// electronics: 'electronics',
				// home_office: 'home & office',
				// stationary: 'stationary',
				// mom_baby: 'mom & baby',
				// pets: 'pets',
				// removeButtons: '',
				the1: 'the1',
				store_voucher: 'crocs',
			},
			pointRange: {
				point_range_apply: '',
				removePointButton: 'removePointButton',
			},
			sortBy: {
				asc: 'asc',
				desc: 'desc',
			},
		};

		Object.keys(filterActions).forEach((key) => {
			Object.keys(filterActions[key]).forEach((btnId) => {
				const value = filterActions[key][btnId];
				document
					.getElementById(btnId)
					?.addEventListener('click', () => {
						this.handleFilterClick(key, value, btnId);
					});
			});
		});
	}

	getTranslatedValue(key, value, btnId) {
		const filterActions = {
			usageChannel: {
				onlineButton: `Online`,
				storeButton: `Cửa hàng`,
				removeButton: '',
			},
			categories: {
				the1: `The1`,
				store_voucher: `Crocs`,
			},
			pointRange: {
				point_range_apply: '',
				removePointButton: 'removePointButton',
			},
			sortBy: {
				asc: `Hết hạn gần nhất`,
				desc: `Mới nhất`,
			},
		};

		if (filterActions[key] && filterActions[key][btnId]) {
			return filterActions[key][btnId];
		} else if (key === 'pointRange') {
			return value;
		} else {
			return value;
		}
	}

	// handle params for API calls
	async handleFilterClick(key, value, btnId) {
		const btn = document.getElementById(btnId);
		if (btn && btnId === 'point_range_apply') {
			btn.classList.add('btn-loading');
            btn.style.pointerEvents = 'none';
		}

		this.spinner.show();
		this.resetModalContent();

		const filterOptionsContainer = this.querySelector('.filter-option');

		if (key === 'usageChannel') {
			this.selectedUsageChannel = value;
			this.params.usageChannel = this.selectedUsageChannel;
			if (this.selectedUsageChannel === '') {
				// Delete if empty
				delete this.params.usageChannel;
			}
			this.updateFilterOption(filterOptionsContainer, key, value, btnId);
		} else if (key === 'categories') {
			this.selectedCategory = value;
			this.params.categories = this.selectedCategory;
			if (this.selectedCategory === '') {
				// Delete if empty
				delete this.params.categories;
			}
			this.updateFilterOption(filterOptionsContainer, key, value, btnId);
		} else if (key === 'pointRange') {
			if (value === 'removePointButton') {
				// Check for the remove button
				delete this.params.fromPoint;
				delete this.params.toPoint;

				this.updateFilterOption(filterOptionsContainer, key, '', btnId);
			} else {
				// Handle the "apply" button case
				const pointRange = this.getSelectedRanges();

				if (pointRange && pointRange.length > 0) {
					this.updateFilterOption(
						filterOptionsContainer,
						key,
						'',
						btnId
					);

					let min = Infinity;
					let max = -Infinity;
					pointRange.forEach((range) => {
						min = Math.min(min, range.min);
						max = Math.max(max, range.max);

						// Thêm từng filter item
						this.updateFilterOption(
							filterOptionsContainer,
							key,
							range.displayValue,
							btnId
						);
					});

					this.params.fromPoint = min;
					this.params.toPoint = max;
				} else {
					this.selectedRanges = [];
					delete this.params.fromPoint;
					delete this.params.toPoint;

					this.updateFilterOption(
						filterOptionsContainer,
						key,
						'',
						btnId
					);
				}
			}
		} else if (key === 'sortBy') {
			this.selectedSortBy = value;
			this.params.sortBy = this.selectedSortBy;
			this.updateFilterOption(filterOptionsContainer, key, value, btnId);
		}

		try {
			await this.filterVouchers(this.params);
		} finally {
			if (btn && btnId === 'point_range_apply') {
				btn.classList.remove('btn-loading');
                btn.style.pointerEvents = '';
			}
		}
	}

	updateFilterOption(container, key, value, btnId) {
		if (!container) return;

		if (key !== 'pointRange') {
			const existingItems = container.querySelectorAll(
				`.item[data-key="${key}"]`
			);
			existingItems.forEach((item) => item.remove());
		}

		if (value && value !== '') {
			const translatedValue = this.getTranslatedValue(key, value, btnId);

			const item = document.createElement('div');
			item.classList.add('item');
			item.dataset.key = key;
			item.dataset.value = value;

			const filterTitle = document.createElement('span');
			filterTitle.classList.add('filter-title');
			filterTitle.textContent = translatedValue;

			const removeIcon = document.createElement('span');
			removeIcon.classList.add('remove-item', 'code-panel-numeric-icon');
			removeIcon.innerHTML = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 4L4 12M4 4L12 12" stroke="#9C9C9C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

			item.appendChild(filterTitle);
			item.appendChild(removeIcon);

			item.addEventListener('click', () => {
				this.spinner.show();
				this.removeFilter(key, value, item);
			});

			const removeAllButton =
				container.querySelector('.remove-all-items');

			if (removeAllButton) {
				container.insertBefore(item, removeAllButton);
			} else {
				container.appendChild(item);
			}
		} else {
			// Nếu xóa filter
			const itemsToRemove = container.querySelectorAll(
				`.item[data-key="${key}"]`
			);
			itemsToRemove.forEach((item) => item.remove());
		}

		this.handleShowFilter();
		this.toggleRemoveAllButton(container);
	}

	handleShowFilter() {
		const filterContainer = document.querySelector('.results-count');

		if (filterContainer) {
			const totalFilters =
				filterContainer.querySelectorAll('.item').length;
			const isSmallScreen = window.innerWidth <= 525;

			if (isSmallScreen) {
				if (totalFilters > 0) {
					filterContainer.classList.add('has-many-filters');
				} else {
					filterContainer.classList.remove('has-many-filters');
				}
			} else {
				if (window.innerWidth > 768) {
					filterContainer.classList.remove('has-many-filters');
				} else {
					if (totalFilters > 2) {
						filterContainer.classList.add('has-many-filters');
					} else {
						filterContainer.classList.remove('has-many-filters');
					}
				}
			}
		}
	}

	removeFilter(key, value, item) {
		const parentContainer = item.parentElement;

		if (key === 'pointRange') {
			const [min, max] = value
				.split(' - ')
				.map((v) => Number(v.replace(/\./g, '')));

			const pointRangeItems = this.selectors.pointFilter.querySelectorAll(
				'.voucher-listing-list input[type="checkbox"]'
			);
			pointRangeItems.forEach((checkbox) => {
				const checkboxMin = parseInt(checkbox.getAttribute('data-min'));
				const checkboxMax = parseInt(checkbox.getAttribute('data-max'));

				const isRangeRemoved = !this.selectedRanges.some(
					(range) =>
						range.min === checkboxMin && range.max === checkboxMax
				);

				// Bỏ chọn checkbox
				if (checkboxMin === min && checkboxMax === max) {
					checkbox.checked = false;
				} else if (isRangeRemoved) {
					checkbox.checked = false;
				}
			});

			// Tìm và xóa range tương ứng trong selectedRanges
			this.selectedRanges = this.selectedRanges.filter(
				(range) => range.min !== min || range.max !== max
			);

			const filterOptionsContainer =
				document.getElementById('filter-options');

			this.updateFilterOption(filterOptionsContainer, key, '', '');
			// Cập nhật lại params dựa trên selectedRanges hiện tại
			const remainingRanges = this.getSelectedRanges();
			if (remainingRanges) {
				remainingRanges.forEach((range) => {
					this.updateFilterOption(
						filterOptionsContainer,
						key,
						range.displayValue,
						''
					);
				});
			}

			if (remainingRanges && remainingRanges.length > 0) {
				let min = Infinity;
				let max = -Infinity;
				remainingRanges.forEach((range) => {
					min = Math.min(min, range.min);
					max = Math.max(max, range.max);
				});
				this.params.fromPoint = min;
				this.params.toPoint = max;
			} else {
				delete this.params.fromPoint;
				delete this.params.toPoint;
			}
		} else {
			delete this.params[key];

			const voucherGroups = this.selectors.typeFilters;
			voucherGroups.forEach((group) => {
				const titleElement = group.querySelector(
					'.voucher-listing-title'
				);
				const associatedKey = titleElement?.getAttribute('data-key');
				if (associatedKey === key) {
					titleElement.textContent =
						titleElement.getAttribute('data-title');
				}

				if (key === associatedKey) {
					const modalContent = titleElement.nextElementSibling;
					const filterItem = modalContent.querySelectorAll('span');

					filterItem.forEach((item) => {
						item.classList.add('hidden');
					});
				}
			});
		}

		item.remove();

		if (parentContainer) {
			this.toggleRemoveAllButton(parentContainer);
		}

		this.handleShowFilter();
		this.filterVouchers(this.params);
	}

	toggleRemoveAllButton(container) {
		let removeAllButton = container.querySelector('.remove-all-items');

		if (!removeAllButton) {
			removeAllButton = document.createElement('span');
			removeAllButton.classList.add('remove-all-items');
			removeAllButton.textContent = `Xóa`;
			container.appendChild(removeAllButton);

			removeAllButton.addEventListener('click', () => {
				this.clearAllFilters(container);
			});
		}

		const hasFilters = container.querySelectorAll('.item').length > 0;
		removeAllButton.style.display = hasFilters
			? removeAllButton.classList.remove('hidden')
			: removeAllButton.classList.add('hidden');
	}

	clearAllFilters(container) {
		const items = container.querySelectorAll('.item');
		items.forEach((item) => item.remove());

		this.params = {};

		const checkboxes = this.selectors.pointFilter.querySelectorAll(
			'.voucher-listing-list input[type="checkbox"]'
		);
		checkboxes.forEach((checkbox) => {
			checkbox.checked = false;
		});

		const voucherGroups = this.selectors.typeFilters;

		voucherGroups.forEach((group) => {
			const titleElement = group.querySelector('.voucher-listing-title');

			if (titleElement) {
				titleElement.textContent =
					titleElement.getAttribute('data-title');
			}

			const modalContent = titleElement.nextElementSibling;
			const filterItem = modalContent.querySelectorAll('span');

			filterItem.forEach((item) => {
				item.classList.add('hidden');
			});
		});

		const filterContainer = document.querySelector('.results-count');

		if (filterContainer) {
			filterContainer.classList.remove('has-many-filters');
		}

		this.handleFilterClick(null, '');
		this.toggleRemoveAllButton(container);
	}

	// close option on API call
	resetModalContent() {
		document
			.querySelectorAll('.voucher-listing-modalContent')
			.forEach((modalContent) => modalContent.classList.remove('active'));

		const listing_box = document.querySelector('.voucher-listing-box.custom-last-position');
		if (listing_box) {
			listing_box.classList.remove('active');
		}
		
	}

	// listener for checkbox option to get point range
	setupPointFilterCheckboxListener() {
		const pointRangeItems = this.selectors.pointFilter.querySelectorAll(
			'.voucher-listing-list input[type="checkbox"]'
		);
		const removeButton = document.getElementById('removePointButton');

		const updateSelectedRanges = () => {
			// this.selectedRanges = [];
			let min = Infinity;
			let max = -Infinity;

			pointRangeItems.forEach((item) => {
				if (item.checked) {
					const rangeMin = parseInt(item.getAttribute('data-min'));
					const rangeMax = parseInt(item.getAttribute('data-max'));
					min = Math.min(min, rangeMin);
					max = Math.max(max, rangeMax);
					// this.selectedRanges.push({ min, max });
				}
			});

			if (min !== Infinity && max !== -Infinity) {
				this.selectedRanges = [{ min, max }];
			} else {
				this.selectedRanges = [];
			}
		};

		const setSelectedRange = () => {
			let startIndex = Infinity;
			let endIndex = -1;

			// Tìm index bắt đầu và kết thúc
			pointRangeItems.forEach((item, index) => {
				if (item.checked) {
					startIndex = Math.min(startIndex, index);
					endIndex = Math.max(endIndex, index);
				}
			});

			// Chọn tất cả checkbox trong khoảng từ startIndex đến endIndex
			for (let index = startIndex; index <= endIndex; index++) {
				const element = pointRangeItems[index];
				element.checked = true;
			}

			// Cập nhật selectedRanges
			updateSelectedRanges();
		};

		pointRangeItems.forEach((checkbox) => {
			checkbox.addEventListener('change', () => {
				setSelectedRange(); // Cập nhật selectedRanges khi checkbox thay đổi
			});
		});

		removeButton.addEventListener('click', () => {
			pointRangeItems.forEach((checkbox) => {
				checkbox.checked = false;
			});
			updateSelectedRanges(); // Cập nhật selectedRanges khi bỏ lọc
		});
	}

	// return min and max of point range
	getSelectedRanges() {
		if (this.selectedRanges.length === 0) return null;
		return this.selectedRanges.map((range) => ({
			min: range.min,
			max: range.max,
			displayValue:
				range.max === 1000000000
					? `${this.formatNumber(
							range.min
					  )} - Trên 100.000`
					: `${this.formatNumber(range.min)} - ${this.formatNumber(
							range.max
					  )}`,
		}));
	}

	// handle close other option and close option on outside click
	setupVoucherTitleEvents() {
		const voucherGroups = this.selectors.typeFilters;
		voucherGroups.forEach((group) => {
			const voucherItems = group.querySelectorAll(
				'.voucher-listing-item'
			);
			const titleElement = group.querySelector('.voucher-listing-title');

			voucherItems.forEach((item) => {
				item.addEventListener('click', () => {
					voucherItems.forEach((otherItem) => {
						if (otherItem !== item) {
							const icon = otherItem.querySelector('span');
							icon.classList.add('hidden');
						}
					});
					const icon = item.querySelector('span');
					icon.classList.remove('hidden');

					this.updateVoucherTitle(item, titleElement);
				});
			});
		});

		const removeButtons = document.querySelectorAll('.removeButton');
		removeButtons.forEach((button) => {
			button.addEventListener('click', () =>
				this.resetVoucherTitle(button)
			);
		});
	}

	updateVoucherTitle(item, titleElement) {
		const value = item.getAttribute('data-value');
		titleElement.textContent = value;
	}

	resetVoucherTitle(button) {
		const group = button.closest('.voucher-listing-box');
		const titleElement = group.querySelector('.voucher-listing-title');
		const defaultTitle = titleElement.getAttribute('data-title');
		titleElement.textContent = defaultTitle;
	}

	// close option A if click open option B
	handleTitleClick() {
		const titles = this.querySelectorAll('.voucher-listing-title');
		const modals = this.querySelectorAll('.voucher-listing-modalContent');
		const listingBox = document.querySelector('.voucher-listing-box.custom-last-position');
		titles.forEach((title) => {
			title.addEventListener('click', (event) => {
				event.stopPropagation();
				const modalContent = title.nextElementSibling;
        const isActive = title.classList.contains('active');
		
		if (listingBox) {
			if (listingBox.classList.contains('active')) {
				listingBox.classList.remove('active')
			}
		} 

        titles.forEach(t => t.classList.remove('active'));
                if (!isActive) {
            title.classList.add('active');
            const modalContent = title.nextElementSibling;
			
			if (listingBox) {
				listingBox.classList.remove('active');
			}

            if (modalContent && modalContent.classList.contains('voucher-listing-modalContent')) {
				if (listingBox) {
					listingBox.classList.add('active');
				}
                modalContent.classList.add('active');
            }
        }

				modals.forEach((modal) => {
					if (listingBox) {
						listingBox.classList.remove('active');
					}

					modal.classList.remove('active');
				});

				if (modalContent !== this.activeModal) {
					modalContent.classList.add('active');
					if (listingBox) {
						listingBox.classList.add('active');
					}

					this.activeModal = modalContent;
					this.updateModalPosition(title, modalContent);

					const items = modalContent.querySelectorAll(
						'.voucher-listing-item'
					);
					items.forEach((item) => {
						item.addEventListener('click', () => {
							const parent = title.closest('[data-filter-type]');
							if (
								parent?.getAttribute('data-filter-type') !==
								'checkbox'
							) {
								this.closeActiveModal();
							}
						});
					});
				} else {
					this.activeModal = null;
				}
			});
		});
	}

	updateModalPosition(title, modalContent) {
		const parentRect = title.getBoundingClientRect();
		const viewportWidth = window.innerWidth;
		const modalWidth = modalContent.offsetWidth;

		let top = parentRect.top + parentRect.height + 8;
		let left = parentRect.left;

		const isPosLastParent =
			title.parentElement.classList.contains('is-pos-last');
		

		if (isPosLastParent) {
			let right;

			const isSafari =
				navigator.userAgent.includes('Safari') &&
				!navigator.userAgent.includes('Chrome') &&
				!navigator.userAgent.includes('Edg');

			const offsetFix = isSafari ? 16 : 0;
			const custom_last_pos = document.querySelector('.custom-last-position');
			const custom_last_pos_listing = document.querySelector('.custom-last-position-listing');

			if (viewportWidth > 1200) {
				right = viewportWidth - parentRect.right - 16 + offsetFix;
				if (custom_last_pos) {
					const modalVoucher = custom_last_pos.querySelector('.voucher-listing-modalContent');
					right = 0;
					top = 62;
					modalVoucher.style.position = 'absolute';
				}

				if (custom_last_pos_listing) {
					const modalVoucher = custom_last_pos_listing.querySelector('.voucher-listing-modalContent');
					right = 0;
					top = 62;
					modalVoucher.style.position = 'absolute';
				}
			} else if (viewportWidth > 767 && viewportWidth <= 1200) {
				right = 30;

				if (custom_last_pos) {
					const modalVoucher = custom_last_pos.querySelector('.voucher-listing-modalContent');
					modalVoucher.style.position = '';
					top+=8;
				}

				if (custom_last_pos_listing) {
					const modalVoucher = custom_last_pos_listing.querySelector('.voucher-listing-modalContent');
					modalVoucher.style.position = '';
					top+=8;
					right = 40;
				}
			} else {
				right = 12;
				top+=8;
			}


			modalContent.style.removeProperty('left');
			modalContent.style.top = `${top}px`;
			modalContent.style.right = `${right}px`;
		} else {

			if (left + modalWidth > viewportWidth) {
				left = viewportWidth - modalWidth - 8;
			}

			if (viewportWidth < 576) {
				left = Math.max(
					8,
					Math.min(left, viewportWidth - modalWidth - 8)
				);
			}

			modalContent.style.left = `${left}px`;
			modalContent.style.top = `${top}px`;
		}
	}

	setupGlobalListeners() {
		// Đóng modal khi click ra ngoài
		document.addEventListener('click', (event) => {
			if (this.activeModal && !this.activeModal.contains(event.target)) {
				this.closeActiveModal();
			}
		});

		window.addEventListener('resize', () => {
			if (this.activeModal) {
				this.closeActiveModal();
			}
		});
		window.addEventListener('scroll', () => {
			if (this.activeModal) {
				this.closeActiveModal();
			}
		});
		const voucherListingFilter = document.querySelector('.voucher-listing');
		if (voucherListingFilter) {
			voucherListingFilter.addEventListener('scroll', () => {
				if (this.activeModal) {
					this.closeActiveModal();
				}
			});
		}
	}

	closeActiveModal() {
		if (this.activeModal) {
			this.activeModal.classList.remove('active');
			const listing_box = document.querySelector('.voucher-listing-box.custom-last-position');
			if (listing_box) {
				listing_box.classList.remove('active');
			}
			this.activeModal = null;
		}
	}

	updateModalPositionOnActive() {
		if (!this.activeModal) return;

		const activeTitle = [
			...document.querySelectorAll('.voucher-listing-title'),
		].find((title) => title.nextElementSibling === this.activeModal);
		if (activeTitle) {
			this.updateModalPosition(activeTitle, this.activeModal);
		}
	}

	handleClickOutside() {
		document.addEventListener('click', (event) => {
			const activeModal = this.activeModal;

			if (activeModal && !activeModal.contains(event.target)) {
				document.querySelectorAll('.voucher-listing-title.active').forEach(el => {
					el.classList.remove('active');
				});
				activeModal.classList.remove('active');
				
				const listing_box = document.querySelector('.voucher-listing-box.custom-last-position');
				
				if (listing_box) {
					listing_box.classList.remove('active');
				}

				this.activeModal = null;
			}
		});
	}

	showLoadingButton(button) {
		button.classList.add('btn-loading');
		button.style.pointerEvents = 'none';
	}

	removeLoadingButton(button) {
		button.classList.remove('btn-loading');
		button.style.pointerEvents = '';
	}

	closeModal() {
		document.documentElement.classList.remove('show-modal', 'no-scroll');
		this.classList.remove('active');
		const listing_box = document.querySelector('.voucher-listing-box.custom-last-position');
		if (listing_box) {
			listing_box.classList.remove('active');
		}
	}

	fakeClickCloseModal() {
		const modal = document.querySelector('crocs-loyalty-modal');
		const overlay = modal.querySelector('.overlay');
		const clickEvent = new MouseEvent('click', {
			view: window,
			bubbles: true,
			cancelable: true,
		});

		if (overlay) {
			overlay.dispatchEvent(clickEvent);
		}
	}

	formatDate(isoDateTime) {
		const dateTime = {
			endDate: 'Invalid Date',
			endTime: 'Invalid Time',
		};
		if (!isoDateTime) return dateTime;

		const date = new Date(isoDateTime);

		if (isNaN(date)) {
			return dateTime;
		}

		dateTime.endDate = date.toLocaleDateString('vi-VN');
		dateTime.endTime = date.toLocaleTimeString('vi-VN', {
			hour: '2-digit',
			minute: '2-digit',
		});

		return dateTime;
	}

	clearVouchers(container) {
		if (container) {
			container.innerHTML = '';
		}
	}

	renderNoResultsMessage() {
		const container = this.config.selectors.vouchersListing;
		if (!container) return;
		container.innerHTML = '';
		const noResultsMessage = document.createElement('p');
		noResultsMessage.textContent = `Không tìm thấy voucher nào.`;
		container.appendChild(noResultsMessage);
	}

	appendNewVouchers(vouchers) {
		this.createProductCards(vouchers);
		this.initializeLoyaltyEvents();
	}

	createProductCards(campaigns) {
		const container = this.config.selectors.vouchersListing;
		if (!container) return;
		campaigns
			// .sort((a, b) => {
			// 	const conditionA =
			// 		a.content.condition !== null
			// 			? a.content.condition.point
			// 			: Infinity;
			// 	const conditionB =
			// 		b.content.condition !== null
			// 			? b.content.condition.point
			// 			: Infinity;
			// 	return conditionB - conditionA;
			// })
			.forEach((campaign) => {
				const cardMarkup = this.renderProductCard(campaign);
				container.insertAdjacentHTML('beforeend', cardMarkup);
			});
	}

	renderProductCard(campaign) {
		const message = new MeowcartLoyaltyMessage();
		const campaignId = campaign?.campaignId;
		const title =
			message.currentLang === 'VI'
				? campaign?.content?.vi?.title
				: `Giảm đến 200.000Đ cho sản phẩm từ 2 triệu đồng khi thanh toán qua ví MoMo`;
		const desc =
			message.currentLang === 'VI'
				? campaign?.content?.vi?.desc
				: campaign?.content?.en?.desc;
		const point =
			this.formatNumber(campaign?.content?.condition?.point) || null;
		const pointMarkup =
			point !== null
				? `<p class="voucher-card-point">Điểm: <span class="verified">${point}</span></p>`
				: '<p class="voucher-card-point free">Miễn phí</p>';
		const btnMarkup =
			point !== null
				? `<span class="btn-text">Quy Đổi</span>`
				: `<span class="btn-text">Thu Thập</span>`;
    const expireDateText = point !== null 
    ? `Quy đổi trước:` 
    : `Thu thập trước:`;
		const contentEndDateTime = campaign?.content?.endDate || '';
		const endDateTime = this.formatDate(contentEndDateTime);
		const endDate = endDateTime.endDate;
		const image =
			campaign?.content?.image ||
			'https://cdn.shopify.com/s/files/1/0696/3783/2958/files/image-2.jpg?v=1726898801';
		const saleChannels = campaign?.content?.usage_channels || [];
		let saleChannelsText = '';

		if (
			saleChannels.includes('Online') &&
			saleChannels.includes('At Store')
		) {
			saleChannelsText = `Online &amp; Cửa hàng`;
		} else if (saleChannels.includes('Online')) {
			saleChannelsText = `Online`;
		} else if (saleChannels.includes('At Store')) {
			saleChannelsText = `Cửa hàng`;
		}

		return `
            <div class="voucher-card-item" data-campaignId="${campaignId}">
				<div>
					<div class="voucher-card-img">
						<img src="${image}" alt="${title}">
                	</div>
                	<p class="voucher-card-expiration">${expireDateText} <span class="voucher-card-expiration-date">${endDate}</span></p>
                	<p class="voucher-card-heading">${title}</p>
					${pointMarkup}
				
				</div>
				<div class="modal-group-buttons">
					<div class="voucher-card-action" data-campaignId='${campaignId}'>
						${btnMarkup}
					</div>
				</div>		
				<div class="voucher-sale-channels">
					${saleChannelsText}
				</div>    
            </div>
        `;
	}

	convertTextToLiTag(voucherText, id, active = '',campaignImages = []) {
		if (!voucherText) {
			return '';
		}

		const voucherItems = voucherText.includes('•')
			? voucherText
					.split('•')
					.map((item) => item.trim())
					.filter((item) => item.length > 0)
			: voucherText
					.split('\n')
					.map((item) => item.trim())
					.filter((item) => item.length > 0);

		const voucherList = document.createElement('ul');
		voucherList.classList.add('voucher-details-note');
		if (active !== '') {
			voucherList.classList.add(active);
		}
		voucherList.id = id;

		voucherItems.forEach((item) => {

			const li = document.createElement('li');
			li.classList.add('voucher-details-txt');
			li.textContent = item;
			voucherList.appendChild(li);
		});


		if (Array.isArray(campaignImages) && campaignImages.length > 0) {
			const imageContainer = document.createElement('div');
			imageContainer.classList.add('container-image');
			
			let count = 0;
			campaignImages.forEach((imgSrc) => {
				const img = document.createElement('img');
				img.src = imgSrc;
				img.alt = 'voucher image';
				if (imgSrc === '') {
					count++;
					img.style.display = 'none';
				}
				imageContainer.appendChild(img);
			});

			if (count === campaignImages.length) {
				imageContainer.style.display = 'none';
			}

			voucherList.appendChild(imageContainer);
		}

		return voucherList.outerHTML;
	}

	clearPagination() {
		const paginationContainer = this.querySelector('.pagination');
		if (paginationContainer) {
			paginationContainer.style.display = 'none';
			paginationContainer.innerHTML = '';
		}
	}

	createPagination() {
		const voucherContainer = this.querySelector('.voucher-items');
		const loadMoreBtn = this.querySelector('.load-more-voucher');

		if (loadMoreBtn && voucherContainer) {
			loadMoreBtn.addEventListener('click', () => {
				handleLoadMoreBtnClick();
			});
		}

		const handleLoadMoreBtnClick = async () => {
			this.showLoadingButton(loadMoreBtn);

			const cursor = this.pagination?.cursor || '';
			const { totals, vouchers } = await this.getVouchers(
				cursor,
				'next',
				this.params
			);

			if (vouchers) {
				this.currentListVoucher =
					this.currentListVoucher.concat(vouchers);
				this.removeLoadingButton(loadMoreBtn);
				this.appendNewVouchers(vouchers);
				this.updateVoucherListingTotals(
					totals,
					this.currentListVoucher.length
				);
			}

			this.updatePaginationButtons();
		};
	}

	updatePaginationButtons() {
		const voucherList = document.querySelector(
			'.voucher-card .voucher-card-list'
		);
		const paginationField = document.querySelector(
			'.voucher-card-inner .pagination'
		);

		if (paginationField) {
			const isHidden =
				this.currentListVoucher.length ===
				this.pagination?.total;

			paginationField.classList.toggle('hidden', isHidden);

			if (voucherList) {
				voucherList.classList.toggle('no-margin', isHidden);
			}
		}
	}

	renderCustomToast({ type, timer, text }) {
		let icon = '';
		if (type === 'success') {
			icon = `
				<span class="code-panel-numeric-icon">
					<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M12.5 24C19.1274 24 24.5 18.6274 24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 18.6274 5.87258 24 12.5 24Z" fill="#70C028"></path>
						<path fill-rule="evenodd" clip-rule="evenodd" d="M19.8371 8.63495L11.1407 17.3313L5.85059 12.0412L7.61835 10.2734L11.1407 13.7958L18.0693 6.86719L19.8371 8.63495Z" fill="#F9F9F9"></path>
					</svg>
				</span>
				`;
		} else if (type === 'error') {
			icon = `
				<span class="code-panel-numeric-icon">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#C00F0C"/>
						<path fill-rule="evenodd" clip-rule="evenodd" d="M17 18.7678L6 7.76777L7.76777 6L18.7678 17L17 18.7678Z" fill="white"/>
						<path fill-rule="evenodd" clip-rule="evenodd" d="M5.99981 17L16.9998 6L18.7676 7.76777L7.76758 18.7678L5.99981 17Z" fill="white"/>
					</svg>
				</span>
			`;
		}

		if (!icon) {
			throw new Error(`Icon not found for type: ${type}`);
		}

		const html = document.createElement('div');
		html.classList.add('custom-toast', 'slide-in');
		html.classList.add(type);
		html.innerHTML = `${icon} ${text}`;
		document.body.appendChild(html);
		setTimeout(() => {
			html.classList.add('slide-back');
			html.addEventListener('animationend', () => {
				document.body.removeChild(html);
			});
		}, timer);
	}

	validateInputPoint(number) {
		const convertErrorText = document.querySelector(
			'.error-message-convert'
		);
		const overPointText = document.querySelector('.error-message-over');

		convertErrorText.classList.add('hidden');
		overPointText.classList.add('hidden');

		if (number < 10000 || number % 1000 !== 0) {
			convertErrorText.classList.remove('hidden');
			return false;
		}

		if (number > this.userData?.wallet?.balances?.current) {
			overPointText.classList.remove('hidden');
			return false;
		}

		return true;
	}

	handleExchangePoint() {
		const targetElements = document.querySelectorAll(
			'[data-button="exchangePoint"]'
		);

		const getModalContent = () => {
			const userElement =
				this.userData?.wallet?.balances?.current ??
				this.userData?.points;
			const userPoints =
				typeof userElement === 'number'
					? userElement.toLocaleString()
					: null;
			// const userPoints = userElement.toLocaleString() || null;
			// this.userData?.wallet?.balances?.current.toLocaleString() ??
			// 	this.userData?.points.toLocaleString() ??
			// 	null;
			const dateElement =
				this.userData?.wallet?.dates ?? this.userData?.dates;
			const dates =
				dateElement !== null || dateElement !== undefined
					? dateElement
					: null;
			const toEndDateString = dates?.end
				? new Date(dates.end).toLocaleDateString('vi-VN')
				: null;

			return `
				<p class="form-user-point">Bạn có ${userPoints} điểm tích luỹ. ${
				toEndDateString
					? `Sử dụng đến ${toEndDateString}`
					: ''
			}</p>
				<div class="form-group form-group-action">
					<input type="text" class="exchange-point-input" oninput="toInputLocaleString(this)" />
					<button type="button" class="btn btn--black-px exchange-point-confirm">Quy đổi</button>
				</div>
				<p class="error-message-convert hidden">
					Số điểm quy đổi phải là bội số của 1000
				</p>
				<p class="error-message-over hidden">Số điểm hiện có của bạn không đủ để thực hiện quy đổi</p>
				<p class="error-message-min hidden">Số điểm tối thiểu để quy đổi là 10,000</p>
				<p class="form-group-caption">Đổi điểm để sử dụng đơn hàng này ( 1 điểm = 1đ )</p>
			`;
		};

		window.toInputLocaleString = (e) => {
			if (e?.value && Number(e.value.replace(/,/g, ''))) {
				e.value = Number(e.value.replace(/,/g, '')).toLocaleString();
			}
		};
		const modalExchangePoint = {
			title: 'Đổi điểm tích lũy',
			content: getModalContent(),
			confirmButton: false,
		};

		if (targetElements) {
			for (const element of targetElements) {
				element.addEventListener('click', () => {
					modalExchangePoint.content = getModalContent();
					this.openModalV2(modalExchangePoint);
				});
			}
			document.addEventListener('click', async (e) => {
				const target = e.target;
				if (target.closest('.exchange-point-confirm')) {
					const value = document.querySelector(
						'.exchange-point-input'
					).value;
					const valueToNumber = Number(value.replace(/,/g, ''));
					const isValid = this.validateInputPoint(valueToNumber);

					if (valueToNumber && isValid) {
						target.disabled = true;
						try {
							const response = await this.apiRequest(
								'POST',
								{
									point: valueToNumber,
								},
								{},
								this.apiEndPoint.exchangePoint
							);

							if (response) {
								const response =
									await this.fetchUserPointsWithLogoutCheck();

								if (response) {
									this.eventBus.emit(
										'voucher_redeemed_loyalty'
									);
									this.closeModal();
									this.renderCustomToast({
										type: 'success',
										text: `Quy đổi điểm thành công. Voucher đã được thêm vào Ví của bạn.`,
										timer: 5000,
									});
								}
							}
						} catch (error) {
							if (error?.response?.data?.error_fields.includes(956)) {
                document.dispatchEvent(new CustomEvent('loyalty:session-expired'));
                return;
              }
							this.openModalV2({
								title: error.message,
								icon: `
											<svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M24.5 48.75C37.7548 48.75 48.5 38.0048 48.5 24.75C48.5 11.4952 37.7548 0.75 24.5 0.75C11.2452 0.75 0.5 11.4952 0.5 24.75C0.5 38.0048 11.2452 48.75 24.5 48.75Z" fill="#FFBB33"/>
												<path fill-rule="evenodd" clip-rule="evenodd" d="M22.0589 33.4197L21.0996 8.78516H27.8181L26.8589 33.4197H22.0589Z" fill="white"/>
												<path fill-rule="evenodd" clip-rule="evenodd" d="M22.1475 35.7891H26.9475V40.5891H22.1475V35.7891Z" fill="white"/>
											</svg>`,
								confirmYesLabel: 'Quay Lại',
								confirmNoLabel: null,
								onConfirm: () => {
									this.openModalV2(modalExchangePoint);
								},
							});
						}
						target.disabled = false;
					} else {
						document.querySelector('.exchange-point-input').focus();
					}
				}
			});
		}
	}

	openModalV2({
		content,
		title,
		icon,
		confirmButton = true,
		confirmYesLabel = 'Thay đổi',
		confirmNoLabel = 'Huỷ thay đổi',
		onConfirm,
		onClose,
	}) {
		document.addEventListener(
			'click',
			(e) => {
				const target = e.target;
				if (target.closest('.close-modal-v2')) {
					e.preventDefault();
					e.stopPropagation();

					if (onClose) {
						if (onClose()) {
							this.closeModal();
						}
					} else {
						this.closeModal();
					}
				}
				if (target.closest('[data-active="confirm-modal-v2"]')) {
					if (onConfirm) {
						if (onConfirm()) {
							this.closeModal();
						}
					} else {
						this.closeModal();
					}
				}
			},
			true
		);

		this.openModal(`
            <div class="modal-step confirm-modal active custom-confirm-modal">
                <header class="modal-header">
					${icon || ''}
                    <p class="modal-header__title ${
						icon !== undefined && icon !== null ? '' : 'mt-0'
					}">${title}</p>
                     <div class="close-modal close-modal-v2">
                        <span class="close-icon"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 5L5 15M5 5L15 15" stroke="#1E1E1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg></span>
                    </div>
                </header>
                <div class="loyalty-modal-content exchange-point">
					${content || ''}
					${
						(confirmButton &&
							`
						<div class="modal-group-buttons">
							${
								(confirmYesLabel &&
									`
								<button class="btn btn--full" data-active="confirm-modal-v2">
									${confirmYesLabel}
								</button>`) ||
								''
							}
							${
								(confirmNoLabel &&
									`
								<button class="btn btn--full btn-secondary close-modal-v2" data-active="close-modal">
									${confirmNoLabel}
								</button>`) ||
								''
							}
						</div>`) ||
						''
					}
                </div>
            </div>
        `);
	}

	renderQR(campaign) {

		const normalizedChannels = campaign?.saleChannels.map((channel) =>
			channel.toLowerCase().trim()
		);
		const isOnline = normalizedChannels.includes('online');
		const isStore = normalizedChannels.includes('at store');

		let applyText = '';
		if (isOnline && isStore) {
			applyText = `Cửa hàng Crocs và  <a href="${this.staging}">Crocs.com.vn</a>`;
		} else if (isOnline) {
			applyText = `<a href="${this.staging}" target=”_blank”>Crocs.com.vn</a>`;
		} else if (isStore) {
			applyText = `Tại các cửa hàng Crocs`;
		}

		const showQRButton = campaign?.saleChannels.includes('Online');
		const codeStyle = campaign?.saleChannels?.length === 1 ? "none" : "flex";
		const markup = `
			<div class="code-panel-inner">
				<div class="code-panel-img">
				<div class="code-panel-title-container">
					<p>Quét mã tại cửa hàng</p>
				</div>
				<div class="code-panel-barcode">
					<img src="${campaign.barcode}" alt="${campaign.title}" loading="lazy">
				</div>
				<div class="code-panel-qrcode">
					<img src="${campaign.qrcode}" alt="${campaign.title}" loading="lazy">
				</div>
				<div class="code-panel-code-container">
					<div class="code-panel-title-container second">
						<p class="code-panel-code-title">Mã giảm giá</p>
					</div>
					<div class="code-panel-numeric-container code-panel-numeric-container-first">
						<p>Tại cửa hàng</p>
						<div class="code-panel-numeric">
							<span class="code-panel-numeric-code">${campaign.token}</span>
							<span class="code-panel-numeric-icon-container copy-button" data-value=${campaign?.token}>
								<!--
									<svg id="clippy" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor">
										<path d="M5.75 4.75H10.25V1.75H5.75V4.75Z" />
										<path d="M3.25 2.88379C2.9511 3.05669 2.75 3.37987 2.75 3.75001V13.25C2.75 13.8023 3.19772 14.25 3.75 14.25H12.25C12.8023 14.25 13.25 13.8023 13.25 13.25V3.75001C13.25 3.37987 13.0489 3.05669 12.75 2.88379" />
									</svg>
								-->
								<svg id="clippy" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M15.6934 3.63086H6.84336C6.20283 3.6313 5.58866 3.88594 5.13574 4.33887C4.68282 4.79179 4.42818 5.40596 4.42773 6.04648V16.4902C4.42818 17.1308 4.68282 17.7449 5.13575 18.1978C5.58867 18.6508 6.20283 18.9054 6.84336 18.9059H15.6934C16.3342 18.9055 16.9488 18.651 17.4022 18.1982C17.8557 17.7453 18.111 17.1311 18.1121 16.4902V6.04648C18.111 5.40563 17.8557 4.7914 17.4022 4.33854C16.9488 3.88569 16.3342 3.63118 15.6934 3.63086Z" fill="#B2B2B2"/>
									<path d="M6.84297 2.69375H15.4273C15.2594 2.22567 14.951 1.82083 14.5444 1.53448C14.1378 1.24813 13.6528 1.09422 13.1555 1.09375H4.30234C3.66198 1.09472 3.04812 1.34954 2.59531 1.80234C2.14251 2.25515 1.88769 2.86901 1.88672 3.50937V13.9531C1.88715 14.4513 2.04136 14.9371 2.3283 15.3443C2.61523 15.7515 3.02089 16.0602 3.48984 16.2281V6.04688C3.49048 5.15777 3.84396 4.30526 4.47266 3.67656C5.10135 3.04787 5.95386 2.69439 6.84297 2.69375Z" fill="#B2B2B2"/>
								</svg>
								<svg id="check" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor">
									<path d="M13.25 4.75L6 12L2.75 8.75" />
								</svg>
							</span>
						</div>
					</div>
					<div class="code-panel-numeric-container" style="display:${codeStyle}">
						<p>Tại Crocs.com.vn</p>
						<div class="code-panel-numeric">
							<span class="code-panel-numeric-code">${campaign.code}</span>
							<span class="code-panel-numeric-icon-container copy-button" data-value=${campaign?.code}>
								<!--
									<svg id="clippy" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor">
										<path d="M5.75 4.75H10.25V1.75H5.75V4.75Z" />
										<path d="M3.25 2.88379C2.9511 3.05669 2.75 3.37987 2.75 3.75001V13.25C2.75 13.8023 3.19772 14.25 3.75 14.25H12.25C12.8023 14.25 13.25 13.8023 13.25 13.25V3.75001C13.25 3.37987 13.0489 3.05669 12.75 2.88379" />
									</svg>
								-->
								<svg id="clippy" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M15.6934 3.63086H6.84336C6.20283 3.6313 5.58866 3.88594 5.13574 4.33887C4.68282 4.79179 4.42818 5.40596 4.42773 6.04648V16.4902C4.42818 17.1308 4.68282 17.7449 5.13575 18.1978C5.58867 18.6508 6.20283 18.9054 6.84336 18.9059H15.6934C16.3342 18.9055 16.9488 18.651 17.4022 18.1982C17.8557 17.7453 18.111 17.1311 18.1121 16.4902V6.04648C18.111 5.40563 17.8557 4.7914 17.4022 4.33854C16.9488 3.88569 16.3342 3.63118 15.6934 3.63086Z" fill="#B2B2B2"/>
									<path d="M6.84297 2.69375H15.4273C15.2594 2.22567 14.951 1.82083 14.5444 1.53448C14.1378 1.24813 13.6528 1.09422 13.1555 1.09375H4.30234C3.66198 1.09472 3.04812 1.34954 2.59531 1.80234C2.14251 2.25515 1.88769 2.86901 1.88672 3.50937V13.9531C1.88715 14.4513 2.04136 14.9371 2.3283 15.3443C2.61523 15.7515 3.02089 16.0602 3.48984 16.2281V6.04688C3.49048 5.15777 3.84396 4.30526 4.47266 3.67656C5.10135 3.04787 5.95386 2.69439 6.84297 2.69375Z" fill="#B2B2B2"/>
								</svg>
								<svg id="check" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor">
									<path d="M13.25 4.75L6 12L2.75 8.75" />
								</svg>
							</span>
						</div>
					</div>
				</div>
			</div>
				<div class="code-panel-detail">
					<div class="code-panel-paragraph">
						<p class="code-panel-txt1">Chi tiết mã giảm giá</p>
						<div class="code-panel-txt2">
							<div class="code-panel-voucher code-panel-txt3 img">
								<img src="${campaign?.image}" alt="${campaign?.title}" loading="lazy">
							</div>
							<span class="code-panel-heading">${campaign.title}</span>
						</div>
						<div class="code-panel-txt2">
							<span class="code-panel-txt3">HSD:</span><span class="code-panel-txt4">${
								campaign.endDate
							}</span>
						</div>
						<div class='code-panel-txt2'>
							<span class='code-panel-txt3'>Áp dụng tại:</span>
							<span class='code-panel-txt4'>${applyText}</span>
						</div>
					</div>
					${
						showQRButton
							? `<div class="code-panel-apply">
									<span class="btn-text">
										Áp dụng
									</span>
								</div>`
							: ''
					}
				</div>
			</div>
		`;

		return markup;
	}

	renderCustomModal(logoSvg, modalTitle, modalDescription, condition) {
		const modalMarkup = `
	        <div class="modal-step confirm-modal active custom-confirm-modal">
	            <header class="modal-header">
	                ${logoSvg}
	                <p class="modal-header__title">${modalTitle}</p>
	                
	            </header>
				${modalDescription ? `<p class="notification-gap">${modalDescription}</p>` : ''}
	            <div class="loyaty-modal-content">
	            <div class="modal-group-buttons">
					${
						condition
							? `<button class="btn btn--full" data-active="back-to-account">
	                    			Cập nhật ngay
	                			</button>`
							: ''
					}
	                <button class="btn btn--full ${
						condition ? 'btn-secondary' : ''
					}" data-active="close-modal">
						Quay lại
	                </button>
	            </div>
	            </div>
	        </div>
	    `;

		return modalMarkup;
	}

	renderRedeemSuccess(modalTitle, modalDescription, icon) {
		const modalMarkup = `
	        <div class="modal-step confirm-modal active custom-confirm-modal">
	            <header class="modal-header">
	                ${icon}
	                <p class="modal-header__title">${modalTitle}</p>
	            </header>
				<p class="announcement">${modalDescription}</p>
	            <div class="loyaty-modal-content">
	                <div class="modal-group-buttons row">
	                    <button class="btn btn--full btn-secondary" data-active="back-to-wallet">
	                        Xem ví
	                    </button>
						<button class="btn btn--full" data-active="show-qr">
							<span class="btn-text">Xem chi tiết</span>
						</button>
	                </div>
	            </div>
	        </div>
	    `;

		return modalMarkup;
	}

	renderPinSubmitModal(
		modalTitle,
		modalDescription,
		logoSvg,
		password,
		hidePassword,
		source
	) {
		console.log(source);
		const pinMarkup = `
	        <div class="modal-step change-modal active">
	            <header class="modal-header">
	                ${logoSvg}
	                <p class="modal-header__title">${modalTitle}</p>
	                
	            </header>

	            <p class="notification-gap">${modalDescription}</p>

	            <div class="loyalty-modal-content-gap">
	                <div class="form-group">
	                    <div class="input_text_parent">
	                        <div class="label-parent">
	                            <label for="pin">Nhập mã PIN<span class="require">*</span></label>
	                            <div class="form-field">
	                                <input
	                                    type="password"
	                                    class="required_value input-field"
	                                    id="pin"
										pattern="[0-9]*"
                						inputmode="numeric"
	                                    name="pin"
	                                    placeholder=""
	                                    value=""
	                                    minlength="6"
	                                    maxlength="6"
	                                    required
	                                />
	                                <span class="field-icon" style="display: inline-block;" data-target="#pin">
	                                    ${password}
	                                </span>
	                                <span class="field-icon" style="display: none;" data-target="#pin">
	                                    ${hidePassword}
	                                </span>
	                            </div>
	                            <ul class="field-errors">
	                                <li><div data-reach-alert="true">Số điện thoại không hợp lệ</div></li>
	                            </ul>
	                        </div>
	                    </div>
	                </div>
	                <div class="modal-group-buttons">
	                    <button class="btn btn--full" data-active="${source}" disabled="disabled">
	                        <span class="btn-text">
	                        Tiếp tục
	                        </span>
	                    </button>
	                </div>
	            </div>
	        </div>
	    `;

		return pinMarkup;
	}

	renderConfirmRedeemModal(modalTitle, modalDescription) {
		const modalMarkup = `
	        <div class="modal-step confirm-modal active">
	            <header class="modal-header">
	                <p class="modal-header__title mt-0">${modalTitle}</p>
	            
	            </header>
				<p class="announcement">${modalDescription}</p>
	            <div class="loyaty-modal-content">
	                <div class="modal-group-buttons row">
	                    <button class="btn btn--full btn-secondary" data-active="close-modal">
	                        Trở lại
	                    </button>
	                    <button class="btn btn--full" data-active="confirm-redeem-voucher">
							<span class="btn-text">Quy Đổi</span>
	                    </button>
	                </div>
	            </div>
	        </div>
	    `;
		return modalMarkup;
	}

	renderVoucherDetail(campaign, type) {
    console.log(campaign.campaignImages);
		const point = this.formatNumber(campaign?.conditionPoint) || null;
		const pointMarkup =
			point !== null
				? `<span class="voucher-details-points">
					Số điểm: <span class="money-tag verified">${point}</span>
				</span>`
				: '';
		const voucherDescription = this.convertTextToLiTag(
			campaign?.desc,
			'voucher-detail',
			'active',
      [] 
		);
		const voucherCondition = this.convertTextToLiTag(
			campaign?.tcs,
			'voucher-condition',
			'',
      Object.values(campaign?.campaignImages || {})
		);

		const saleChannels = campaign?.saleChannels || [];
		let saleChannelsText = '';

		if (
			saleChannels.includes('Online') &&
			saleChannels.includes('At Store')
		) {
			saleChannelsText = `Cửa hàng Crocs và  <a href="${this.staging}" target=”_blank”>Crocs.com.vn</a>`;
		} else if (saleChannels.includes('Online')) {
			saleChannelsText = `<a href="${this.staging}" target=”_blank”>Crocs.com.vn</a>`;
		} else if (saleChannels.includes('At Store')) {
			saleChannelsText = `Tại các cửa hàng Crocs`;
		}

		let btn;
		let expiryText;
		if (type === 'details') {
			if (
				saleChannels.includes('Online') &&
				saleChannels.includes('At Store')
			) {
				btn = `
				<div class="modal-group-buttons row jtf-bw">
					<div class="qr-voucher-btn loyalty-button-secondary w-100">
						<span class="btn-text">Mở mã QR</span>
					</div>
					<div class="apply-voucher-btn loyalty-button-primary w-100">
						<span class="btn-text">Áp dụng</span>
					</div>
				</div>
			`;
			} else if (saleChannels.includes('Online')) {
				btn = `
				<div class="apply-voucher-btn loyalty-button-primary">
					<span class="btn-text">Áp dụng</span>
				</div>
			`;
			} else if (saleChannels.includes('At Store')) {
				btn = ` 
				<div class="qr-voucher-btn loyalty-button-primary">
					<span class="btn-text">Mở mã QR</span>
				</div>
			`;
			}

			expiryText = `Quy đổi trước:`;
		} else {
			btn =
				point !== null
					? `<div class="modal-group-buttons custom-redeem-voucher-btn">
							<div class="redeem-voucher-btn">
								<span class="btn-text">
									Xác nhận Quy đổi
								</span>	
							</div>
						</div>`
					: `<div class="modal-group-buttons custom-redeem-voucher-btn">
							<div class="redeem-voucher-btn">
								<span class="btn-text">
									Xác nhận Thu thập
								</span>	
							</div>
						</div>`;
			expiryText = 'HSD:';
		}
		const markup = `
				<div class="voucher-details-inner">
				<div class="voucher-details-top custom-voucher-details-top">
					<div class="voucher-details-img custom-voucher-details-img">
						<img src="${campaign?.image}" alt="${campaign?.title}" loading="lazy">
						<div class="voucher-details-ttl custom-voucher-details-ttl hide-desktop">${campaign?.title}</div>
					</div>
					<div class="voucher-details-modal-right custom-voucher-details-modal-right">
						<div class="voucher-details-ttl custom-voucher-details-ttl hide-mobile">${campaign?.title}</div>
						<div class="voucher-details-expiry-text">
							<span class="voucher-details-expiry-container custom-voucher-details-expiry-container">
								<span class="custom-voucher-details-expiry-text">Hạn sử dụng: </span>
								<span class="voucher-details-expiry-date">
									${campaign?.endDate}
								</span>	
							</span>
							<span class="voucher-details-expiry custom-voucher-details-expiry-container">
								<span class="voucher-details-sale-channels custom-voucher-details-expiry-text">Áp dụng tại: </span>
								<span class="voucher-details-expiry-sale-text">${saleChannelsText}</span>
							</span>
						</div>
						${btn}
					</div>
				</div>
				<div class="voucher-details-bottom">
					<div class="voucher-details-label">
						<span class="title active" data-target="voucher-detail">Chi tiết ưu đãi</span>
						<span class="title" data-target="voucher-condition">Điều kiện sử dụng</span>
					</div>
					${voucherDescription}
					${voucherCondition}
				</div>
				
			</div>
		`;

		return markup;
	}

	openModal(response, source = null) {
		return new Promise((resolve) => {
			const modal = document.querySelector('crocs-loyalty-modal');
			const modalContainer = modal.querySelector('.loyalty-modal');
			const modalContent = modal.querySelector('#loyalty-modal-content');

			const isModalActive = modal.classList.contains('active');

			if (isModalActive) {
				modalContainer.classList.add('slide-down');
			}

			const updateModalContent = () => {
				if (source === 'voucher' || source === 'qr') {
					modalContainer.classList.add('voucher');
				} else {
					modalContainer.classList?.remove('voucher');
				}
				modalContent.innerHTML = response;

				if (source === 'submit-pin') {
					this.handlePinModalButton(modalContent);
				}

				if (source === 'cash-voucher') {
					this.handleCashVoucher(modalContent);
				}

				this.initModal();

				if (isModalActive) {
					modalContainer.classList.remove('slide-down');
				}

				resolve(modal);
			};

			if (isModalActive) {
				setTimeout(updateModalContent, 700);
			} else {
				updateModalContent();
			}

			document.documentElement.classList.add('show-modal', 'no-scroll');
			modal.classList.add('active');
		});
	}

	handleNotValidateUserData() {
		const icon = this.icon.logoSvg;
		const modalTitle = `Chưa cập nhật thông tin`;
		const modalDescription = `Để sử dụng tính năng quy đổi và thu thập voucher, bạn cần bổ sung đầy đủ thông tin cá nhân!`;
		const response = this.renderCustomModal(
			icon,
			modalTitle,
			modalDescription,
			'not-validate'
		);
		this.openModal(response).then(() => {
			this.handleNavigateToAccount();
		});
	}

	isMobileDevice() {
		return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
	}

	handleNavigateToAccount() {
		const accountBtn = document.querySelector(
			'button[data-active="back-to-account"]'
		);
		const accountTab = document.querySelector(
			'tab-button[tab-id="account"]'
		);
		const accountInfoTab = document.querySelector(
			'tab-button[tab-id="account-info"]'
		);
		const targetUrl = `${this.staging}/account#tab-account-tab-account-info`;

		if (accountBtn) {
			accountBtn.addEventListener('click', () => {
				if (!window.location.href.startsWith(targetUrl.split('#')[0])) {
					window.location.href = targetUrl;
				} else {
					const loyaltyHref = `${this.staging}/account#tab-loyalty-tab-vouchers`;
					if (
						this.isMobileDevice() &&
						window.location.href === loyaltyHref
					) {
						const loyalty = document.querySelector(
							'tab-content #loyalty'
						);
						const loyaltyPage = loyalty.querySelector('#vouchers');
						const account = document.querySelector(
							'tab-content #account'
						);
						const accountPage =
							account.querySelector('#account-info');

						this.fakeClickCloseModal();

						loyalty.classList.remove('active-mobile');
						loyaltyPage.classList.remove('active-mobile');

						account.classList.add('active-mobile');
						
						const subTabContents = account.querySelectorAll('.sub-tab-content-item');
						subTabContents.forEach(content => {
							content.classList.remove('active-mobile');
							content.classList.remove('active');
						});

						accountPage.classList.add('active-mobile');
						accountPage.classList.add('active');
						
						if (accountInfoTab) {
							const allSubButtons = account.querySelectorAll('.sub-tab-button');
							allSubButtons.forEach(btn => btn.classList.remove('active'));
							accountInfoTab.classList.add('active');
						}

						account.scrollIntoView({
							behavior: 'smooth',
							block: 'start',
						});
					} else {
						this.fakeClickCloseModal();
						if (accountTab) {
							accountTab.click();
						}
						if (accountInfoTab) {
							accountInfoTab.click();
						}

						const new_user = document.querySelector('.new-user');
						if (new_user) {
							if (accountTab) {
								accountTab.scrollIntoView({
									behavior: 'smooth',
									block: 'start'
								});
							}
						}
					}
				}
			});
		}
	}

	handleNotEnoughPoint() {
		const icon = this.icon.logoSvg;
		const modalTitle = `Không đủ điểm quy đổi`;
		const response = this.renderCustomModal(icon, modalTitle);
		this.openModal(response);
	}

	renderLockedModal(title, desc, timeRemaining) {
		const modalMarkup = `
            <div class="modal-step lock-modal active">
                <header class="modal-header">
                    <p class="modal-header__title mt-0">${title}</p>
                    
                </header>
                <div class="loyaty-modal-content">
                    <div class="otp-notification center">
						<span>
							Vui lòng thử lại sau
                        	<strong class="time-remaining blue">${timeRemaining}</strong>
						</span>
						<br>
                        <p class="locked-desc">${desc}</p>
                    </div>
 
                    <div class="modal-group-buttons">
                        <button class="btn btn--full" data-active="close-modal">
                            Quay lại
                        </button>
                    </div>
                </div>
            </div>
        `;

		return modalMarkup;
	}

	handlePinModalButton(modal) {
		const pinInput = modal.querySelector('input[name="pin"]');
		const modalBtnChangeSave = modal.querySelector(
			'[data-active="submit-pin"]'
		);

		console.log(pinInput);
		console.log(modalBtnChangeSave);

		if (pinInput && modalBtnChangeSave) {
			const checkPinValidity = () => {
				pinInput.value = pinInput.value.replace(/[^0-9]/g, '');
				const pinValue = pinInput.value.trim();
				const isValidPin =
					pinValue.length === 6 && /^\d+$/.test(pinValue);
				modalBtnChangeSave.disabled = !isValidPin;
			};

			checkPinValidity();

			pinInput.addEventListener('input', checkPinValidity);

			modalBtnChangeSave.addEventListener('click', async () => {
				if (!modalBtnChangeSave.disabled) {
					const pinValue = pinInput.value;

					this.showLoadingButton(modalBtnChangeSave);

					const isUser = await this.verifyPin(pinValue);

					try {
						if (!isUser.success) {
							this.removeLoadingButton(modalBtnChangeSave);
						} else {
							const campaignId =
								this.currentVoucherData.campaignId;
							const redeemResult = await this.redeemVoucher(
								campaignId
							);

							if (!redeemResult.success) {
								this.removeLoadingButton(modalBtnChangeSave);
								this.fakeClickCloseModal();
								this.renderCustomToast({
									type: 'error',
									text:
										redeemResult.error.message ||
										`Xảy ra lỗi trong việc lưu Voucher!`,
									timer: 3000,
								});
							} else {
								const response =
									await this.fetchUserPointsWithLogoutCheck();
								if (response) {
									const currentVoucherData =
										redeemResult?.data;
									const endDateTime = this.formatDate(
										currentVoucherData?.valid_to
									);
									const endDate = endDateTime.endDate;
									const endTime = endDateTime.endTime;
									const modalTitle = `Quy đổi thành công`;
									const modalDescription = `Khuyến mãi có giá trị tới ${endTime} ${endDate}`;
									const icon = this.icon.greenDoneIcon;
									const responseMarkup =
										this.renderRedeemSuccess(
											modalTitle,
											modalDescription,
											icon
										);
									this.openModal(responseMarkup).then(() => {
										this.handleShowVoucherDetails(
											currentVoucherData
										);
										this.navigateToWallet();
									});
								}
							}
						}
					} catch (error) {
						console.error(error);
					} finally {
						this.removeLoadingButton(modalBtnChangeSave);
					}
				}
			});
		}
	}

	async handleConfirmRedeemModalV2(verifiedState) {
		if (verifiedState) {
			this.pinSubmitModal();

			return false;
		} else {
			const redeemResult = await this.redeemVoucher(
				this.currentVoucherData.campaignId
			);
			// const text = redeemResult?.error?.error?.response?.data?.error_data?.errorMessage.includes('Suspended')
			// 	? `Lỗi: Voucher đã bị tạm ngưng.`
			// 	: redeemResult.error.message;
      const text = redeemResult.error.message;
			
			if (!redeemResult.success) {
				this.fakeClickCloseModal();
				this.renderCustomToast({
					type: 'error',
					text:
						text ||
						`Xảy ra lỗi trong việc lưu Voucher!`,
					timer: 3000,
				});

				return false;
			} else {
				const response = await this.fetchUserPointsWithLogoutCheck();

				if (response) {
					const currentVoucherData = redeemResult?.data;

					const endDateTime = this.formatDate(
						currentVoucherData?.valid_to
					);
					const endDate = endDateTime.endDate;
					const endTime = endDateTime.endTime;
					const point =
						currentVoucherData?.content?.condition || null;
					const modalTitle =
						point !== null
							? `Quy đổi thành công`
							: `Thu thập thành công`;
					const modalDescription = `Khuyến mãi có giá trị tới ${endTime} ${endDate}`;
					const icon = this.icon.greenDoneIcon;
					const responseMarkup = this.renderRedeemSuccess(
						modalTitle,
						modalDescription,
						icon
					);
					this.openModal(responseMarkup).then(() => {
						this.handleShowVoucherDetails(currentVoucherData);
						this.navigateToWallet();
					});
				}

				return true;
			}
		}
	}

	handleConfirmRedeemModal(verifiedState) {
		const modal = document.querySelector('crocs-loyalty-modal');
		if (modal) {
			const confirmRedeemBtn = modal.querySelector(
				'button[data-active="confirm-redeem-voucher"]'
			);

			if (confirmRedeemBtn) {
				confirmRedeemBtn.addEventListener('click', async () => {
					if (
						this.currentVoucherData?.conditionPoint === 0 ||
						this.currentVoucherData?.conditionPoint === null
					) {
						this.showLoadingButton(confirmRedeemBtn);
						const redeemResult = await this.redeemVoucher(
							this.currentVoucherData.campaignId
						);

						if (!redeemResult.success) {
							this.removeLoadingButton(confirmRedeemBtn);
							this.fakeClickCloseModal();
						} else {
							const response =
								await this.fetchUserPointsWithLogoutCheck();
							if (response) {
								const endDate =
									this.currentVoucherData?.endDate;
								const endTime =
									this.currentVoucherData?.endTime;
								const modalTitle = `Quy đổi thành công`;
								const modalDescription = `Khuyến mãi có giá trị tới ${endTime} ${endDate}`;
								const icon = this.icon.greenDoneIcon;

								const responseMarkup = this.renderRedeemSuccess(
									modalTitle,
									modalDescription,
									icon
								);
								this.openModal(responseMarkup).then(() => {
									this.handleShowVoucherDetails();
									this.navigateToWallet();
								});
							}
						}
					} else {
						this.showLoadingButton(confirmRedeemBtn);

						if (verifiedState && this.config.userData.PIN !== '') {
							const redeemResult = await this.redeemVoucher(
								this.currentVoucherData.campaignId
							);

							if (!redeemResult.success) {
								this.removeLoadingButton(confirmRedeemBtn);
								this.fakeClickCloseModal();
								this.renderCustomToast({
									type: 'error',
									text:
										redeemResult.error.message ||
										`Xảy ra lỗi trong việc lưu Voucher!`,
									timer: 3000,
								});
							} else {
								const response =
									await this.fetchUserPointsWithLogoutCheck();
								if (response) {
									const endDate =
										this.currentVoucherData?.endDate;
									const endTime =
										this.currentVoucherData?.endTime;
									const modalTitle = `Quy đổi thành công`;
									const modalDescription = `Khuyến mãi có giá trị tới ${endTime} ${endDate}`;
									const icon = this.icon.greenDoneIcon;

									const responseMarkup =
										this.renderRedeemSuccess(
											modalTitle,
											modalDescription,
											icon
										);
									this.openModal(responseMarkup).then(() => {
										this.handleShowVoucherDetails();
										this.navigateToWallet();
									});
								}
							}
						} else {
							this.pinSubmitModal();
						}
					}
				});
			}
		}
	}

	handleRedeemBtnClickV2 = async (verifiedState = true) => {
		const needVerifyPin =
			this.currentVoucherData?.conditionPoint !== null &&
			this.currentVoucherData?.conditionPoint > 0;

		if (needVerifyPin) {
			const shouldShowPinPrompt = !verifiedState;
			return await this.handleConfirmRedeemModalV2(shouldShowPinPrompt);
		} else {
			return await this.handleConfirmRedeemModalV2(needVerifyPin);
		}
	};

	async handleRedeemBtnClick() {
		const exchangeBtn = document.querySelector('.btn-exchange');
		this.showLoadingButton(exchangeBtn);

		try {
			const verifyState = await this.getVerifiedState();
			if (!verifyState) {
				console.log("Stated verification failed");
				this.pinSubmitModal('cash-voucher');
				return;
			}
			await this.handleConfirmConvertPointsToCash();
		} catch (error) {
			console.error(error);
		} finally {
			this.removeLoadingButton(exchangeBtn);
		}
	}

	handleCashVoucher(modal) {
		const pinInput = modal.querySelector('input[name="pin"]');
		const modalBtnChangeSave = modal.querySelector(
			'[data-active="cash-voucher"]'
		);

		if (pinInput && modalBtnChangeSave) {
			const checkPinValidity = () => {
				pinInput.value = pinInput.value.replace(/[^0-9]/g, '');
				const pinValue = pinInput.value.trim();
				const isValidPin =
					pinValue.length === 6 && /^\d+$/.test(pinValue);
				modalBtnChangeSave.disabled = !isValidPin;
			};

			checkPinValidity();

			pinInput.addEventListener('input', checkPinValidity);

			modalBtnChangeSave.addEventListener('click', async () => {
				if (!modalBtnChangeSave.disabled) {
					const pinValue = pinInput.value;

					this.showLoadingButton(modalBtnChangeSave);

					const isUser = await this.verifyPin(pinValue);

					try {
						if (!isUser.success) {
							this.removeLoadingButton(modalBtnChangeSave);
						} else {
							await this.handleConfirmConvertPointsToCash();
						}
					} catch (error) {
						console.error(error);
					} finally {
						this.removeLoadingButton(modalBtnChangeSave);
					}
				}
			});
		}
	}

	pinSubmitModal(source = 'submit-pin') {
		const modalTitle = `Nhập mã PIN`;
		const modalDescription = `Vui lòng nhập mã PIN của bạn gồm 6 số để xác thực`;
		const logoSvg = this.icon.logoSvg;
		const iconPassword = this.icon.iconPassword;
		const iconHidePassword = this.icon.iconHidePassword;
		const response = this.renderPinSubmitModal(
			modalTitle,
			modalDescription,
			logoSvg,
			iconPassword,
			iconHidePassword,
			source
		);

		this.openModal(response, source);
	}

	handleVoucherDetailDescClick() {
		const modal = document.querySelector('crocs-loyalty-modal');
		const titles = modal.querySelectorAll('.voucher-details-bottom .title');
		const descs = modal.querySelectorAll(
			'.voucher-details-bottom .voucher-details-note'
		);

		titles.forEach((title) => {
			title.addEventListener('click', () => {
				titles.forEach((t) => t.classList.remove('active'));

				title.classList.add('active');

				descs.forEach((desc) => desc.classList.remove('active'));

				const targetId = title.getAttribute('data-target');
				document.getElementById(targetId)?.classList.add('active');
			});
		});
	}

	handleRedeemModalClick() {
		const modal = document.querySelector('crocs-loyalty-modal');

		if (modal) {
			const redeemBtn = modal.querySelector('.redeem-voucher-btn');

			if (redeemBtn) {
				redeemBtn.addEventListener('click', async () => {
					if (!this.config.userToken) {
						const notifycation = document.querySelector(
							'.loyalty-notification-non-login'
						);
						this.fakeClickCloseModal();
						notifycation.scrollIntoView({
							block: 'center',
							behavior: 'smooth'
						});
            notifycation.classList.add('pulse-animation');

    
    setTimeout(() => {
        notifycation.classList.remove('pulse-animation');
    }, 3000);
					} else {
						const userState =
							this.userData?.profile?.state === 'EARNONLY';

						if (userState) {
							this.handleNotValidateUserData();
						} else {
							try {
								this.showLoadingButton(redeemBtn);

								const verifyState =
									await this.getVerifiedState();
								const conditionPointNumber = Number(
									this.currentVoucherData.conditionPoint
								);

								const userPoint =
									this.userData?.wallet?.balances?.current ??
									this.config?.mainAccount?.userData?.points;

								if (userPoint < conditionPointNumber) {
									this.handleNotEnoughPoint();
								} else {
									console.log('Clicked')
									await this.handleRedeemBtnClickV2(
										verifyState
									);
								}
							} finally {
								this.removeLoadingButton(redeemBtn);
							}
						}
					}
				});
			}
		}
	}

	findByCampaignId(campaigns, campaignId) {
		return (
			campaigns.find((campaign) => campaign.campaignId === campaignId) ||
			null
		);
	}

	backToAccountTab() {
		const notiUpdateProfileButton = document.querySelector(
			'.loyalty-notification b'
		);

		if (notiUpdateProfileButton) {
			notiUpdateProfileButton.addEventListener('click', () => {
				const url = `${this.staging}/account#tab-account-tab-account-info`;
				window.location.href = url;
			});
		}
	}

	initializeLoyaltyEvents() {
		const voucherItems = this.querySelectorAll('.voucher-card-item:not(.event-initialized)');

		voucherItems.forEach((item) => {
			item.classList.add('event-initialized');
			item.addEventListener('click', async (event) => {
				const campaignId = Number(item.getAttribute('data-campaignid'));
				if (!campaignId) return;

				const thisButton = item.querySelector('.voucher-card-action');

				// Nếu campaignId cụ thể, xử lý riêng
				if (campaignId === 100398794) {
					if (window.location.pathname === '/pages/voucher-listing') {
						this.activateExchangePointTab('exchangePoint');
					} else {
						this.navigateToCashVoucherPage();
					}
					return;
				}

				this.showLoadingButton(thisButton);

				try {
					const campaignData = this.findByCampaignId(
						this.currentListVoucher,
						campaignId
					);

					if (campaignData) {
						const message = new MeowcartLoyaltyMessage();

						const voucherData = {
              campaignImages: campaignData?.content?.images,
							campaignId: campaignData?.campaignId,
							conditionPoint:
								campaignData?.content?.condition?.point || null,
							point: campaignData?.reward || null,
							title:
								message.currentLang === 'VI'
									? campaignData?.content?.vi?.title
									: campaignData?.content?.en?.title,
							desc:
								message.currentLang === 'VI'
									? campaignData?.content?.vi?.desc ||
									  `Không có mô tả`
									: campaignData?.content?.en?.desc ||
									  `Không có mô tả`,
							...this.formatDate(campaignData?.content?.endDate),
							tcs:
								message.currentLang === 'VI'
									? campaignData?.content?.vi?.tcs ||
									  `Không có thông tin điều khoản và điều kiện`
									: campaignData?.content?.en?.tcs ||
									  `Không có thông tin điều khoản và điều kiện`,
							saleChannels:
								campaignData?.content?.usage_channels || [],
							image:
								campaignData?.content?.image ||
								'https://cdn.shopify.com/s/files/1/0696/3783/2958/files/image-1.jpg?v=1726898800',
						};

						this.currentVoucherData = voucherData;

						const voucherDetailMarkup = this.renderVoucherDetail(
							voucherData,
							''
						);
						this.openModal(voucherDetailMarkup, 'voucher').then(
							() => {
								this.handleVoucherDetailDescClick();
								this.handleRedeemModalClick();
							}
						);
					} else {
						this.renderCustomToast({
							type: 'error',
							text: `Xảy ra lỗi trong việc lưu Voucher!`,
							timer: 3000,
						});
					}
				} catch(err) {
					console.error('something goes wrong', err)
				} finally {
					this.removeLoadingButton(thisButton);
				}
			});
		});
	}

	initModal() {
		const modal = document.querySelector('crocs-loyalty-modal');
		if (modal) {
			modal.init();
		}
	}

	async synchronizeCoupons() {
		try {
			const response = await this.apiRequest(
				'POST',
				{},
				{},
				this.apiEndPoint.synchronizeCoupons
			);

			return response;
		} catch (error) {
			console.error('synchronizeCoupons', error);
		}
	}

	async findCampaignIdAndToken(targetCampaignId) {
		let foundCampaign = false;
		try {
			const sync = await this.synchronizeCoupons();
			if (sync) {
				const response = await this.apiRequest(
					'POST',
					{},
					{
						usageChannel: 'Online,Instore',
						cursor: null,
						action: 'next',
						firstPage: true,
						status: 'active',
						pageSize: 12,
					},
					this.apiEndPoint.getCoupons
				);

				if (response.status === 200) {
					const coupons = response.data.data;
					for (const coupon of coupons) {
						if (foundCampaign) {
							break;
						}
						if (coupon?.details?.campaignId === targetCampaignId) {
							foundCampaign = true;

							return coupon;
						}
					}
				}
			}
		} catch (error) {
			console.error(error);
		}
	}

	async verifyPin(pinValue) {
		const data = JSON.stringify({
			pin: pinValue,
		});

		try {
			const response = await this.apiRequest(
				'POST',
				data,
				{},
				this.apiEndPoint.verifyPin
			);

			if (response?.status === 200) {
				this.config.userData.PIN = pinValue;
				localStorage.setItem("loyalty_last_verified_at", new Date().toISOString());
				return { success: true, error: '' };
			}

			return { success: false, error: error };
		} catch (error) {
			const errorCodes = error?.response?.data?.error_fields || [];
			if (errorCodes.includes(956)) {
				document.dispatchEvent(new CustomEvent('loyalty:session-expired'));
				return;
			}

			if (error.code === 911) {
				const ta = parseInt(error?.error?.response.headers.ta);
				const remaining = this.formatDate(ta);
				const timeRemaining = `${remaining.endTime} ${remaining.endDate}`;
				const title = `Khóa tạm thời`;
				const desc = `Tài khoản của bạn đã bị khóa tạm thời do nhập sai mã PIN 3 lần.`;

				const responseConfirm = this.renderLockedModal(
					title,
					desc,
					timeRemaining
				);
				this.openModal(responseConfirm);
			}

			return { success: false, error: error };
		}
	}

	async redeemVoucher(campaignId) {
		try {
			const body = JSON.stringify({ campaignId: campaignId });

			const response = await this.apiRequest(
				'POST',
				body,
				{},
				this.apiEndPoint.collectVoucher
			);

			if (response?.status === 200) {
				this.eventBus.emit('voucher_redeemed_loyalty');
				const data = response?.data?.data || {};

				return { success: true, data: data, error: '' };
			}
		} catch (error) {
      if (error?.response?.data?.error_fields.includes(956)) {
        document.dispatchEvent(new CustomEvent('loyalty:session-expired'));
        return;
      }
			return { success: false, data: '', error: error };
		}
	}

	navigateToWallet() {
		const modal = document.querySelector('crocs-loyalty-modal');

		if (modal) {
			const navigateWalletBtn = modal.querySelector(
				'button[data-active="back-to-wallet"]'
			);

			if (navigateWalletBtn) {
				navigateWalletBtn.addEventListener('click', () => {
					this.eventBus.emit('back_to_loyalty');
					const walletTabButton = this.querySelector(
						'tab-header .sub-tab-button[tab-id="wallet"]'
					);
					if (walletTabButton) {
						walletTabButton.click(); // Trigger the click event on the wallet tab button
					} else {
						window.location.href =
							'/account#tab-loyalty-tab-wallet';
					}
				});
			}
		}
	}

	handleShowVoucherQR(campaign) {
		const qrMarkup = this.renderQR(campaign);
		const code = campaign.code;
		const token = campaign.token;

		this.openModal(qrMarkup, 'qr').then(() => {
			this.handleApplyVoucher(code, token);
		});
	}

	async handleShowVoucherDetails(campaign) {
		const modal = document.querySelector('crocs-loyalty-modal');

		if (modal) {
			const showQR = modal.querySelector('button[data-active="show-qr"]');

			if (showQR) {
				showQR.addEventListener('click', async () => {
					try {
						this.showLoadingButton(showQR);

						if (!campaign) {
							console.error('No coupon details found.');
							return;
						}

						const contentEndDateTime = campaign?.valid_to || '';
						const endDateTime = this.formatDate(contentEndDateTime);
						const endDate = endDateTime.endDate;
						const barcode = this.generator.generateBarCode(
							campaign?.token
						);
						const qrcode = this.generator.generateQRCode(
							campaign?.token
						);
						const code = campaign?.code;
						const token = campaign?.token;
						const message = new MeowcartLoyaltyMessage();

						const voucherData = {
              campaignImages: campaign?.content?.images,
							camnpaignId: campaign?.campaignId,
							code: code,
							token: token,
							title:
								message.currentLang === 'VI'
									? campaign.content?.vi?.title
									: campaign?.content?.en?.title,
							desc:
								message.currentLang === 'VI'
									? campaign?.content?.vi?.desc ||
									  `Không có mô tả`
									: campaign?.content?.en?.desc ||
									  `Không có mô tả`,
							tcs:
								message.currentLang === 'VI'
									? campaign?.content?.vi?.tcs ||
									  `Không có thông tin điều khoản và điều kiện`
									: campaign?.content?.en?.tcs ||
									  `Không có thông tin điều khoản và điều kiện`,
							image:
								campaign?.content?.image ||
								'https://cdn.shopify.com/s/files/1/0696/3783/2958/files/image-2.jpg?v=1726898801',
							saleChannels:
								campaign?.content?.usage_channels || [],
							endDate: endDate,
							barcode: barcode,
							qrcode: qrcode,
						};

						const voucherDetailMarkup = this.renderVoucherDetail(
							voucherData,
							'details'
						);

						this.openModal(voucherDetailMarkup, 'voucher').then(
							() => {
								this.handleVoucherDetailDescClick();

								const modal = document.querySelector(
									'crocs-loyalty-modal'
								);

								const applyBtn =
									modal.querySelector('.apply-voucher-btn');

								const openQR =
									modal.querySelector('.qr-voucher-btn');

								if (openQR) {
									openQR.addEventListener('click', () => {
										this.handleShowVoucherQR(voucherData);
									});
								}

								if (applyBtn) {
									this.handleApplyDiscountButton(
										applyBtn,
										code
									);
								}
							}
						);
					} catch (error) {
						console.error('Error showing voucher QR:', error);
					} finally {
						this.removeLoadingButton(showQR);
					}
				});
			}
		}
	}

	async addDiscount(discounts, redirect = location.pathname) {
		const cartData = await fetch('/cart.js').then((response) =>
			response.json()
		);

		const currentDiscounts = cartData.cart_level_discount_applications.map(
			(item) => item.title
		);
		const newDiscounts = discounts.filter(
			(discount) => !currentDiscounts.includes(discount)
		);

		if (newDiscounts.length > 0) {
			const discountTitles = [...currentDiscounts, ...newDiscounts];

			const response = await this.fetchData(
				this.apiEndPoint.discountUpdate,
				{ cartId: cartData.token, discountCodes: discountTitles },
				{}
			);

      console.log('addDiscount: response của /discount/update 2', response);
      

			if (response) {
				if (cartData.item_count < 1) {
					const url = new URL(redirect);
					url.searchParams.set('cart', 'empty');
					location.href = url.toString();
				} else {
					location.href = redirect;
				}


			}
		} else {
			if (cartData.item_count < 1) {
				const url = new URL(redirect);
				url.searchParams.set('cart', 'empty');
				location.href = url.toString();
			} else {
				location.href = redirect;
			}
		}
	}

	async fetchData(endpoint, body = {}, params = {}) {
		const queryParams = new URLSearchParams(params).toString();
		let url = `${this.provider.hostName}${endpoint}${
			queryParams ? '?' + queryParams : ''
		}`;
		if (url.includes("/the1/shopify")) {
			url = url.replace("/the1/shopify", "/shopify");
		}
		try {
			const response = await fetch(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-User-Token': this.config.userToken,
				},
				body: JSON.stringify(body),
			});
			if (!response.ok)
				throw new Error(`HTTP error! status: ${response.status}`);
			const result = await response.json();
			if (!result.status)
				throw new Error(
					result.message || `Có lỗi xảy ra`
				);
			return result;
		} catch (error) {
			throw new Error(error);
		}
	}

	handleApplyDiscountButton(applyButton, code) {
		if (applyButton) {
			applyButton.addEventListener('click', async () => {
				this.showLoadingButton(applyButton);

				try {
					this.addDiscount([code], `${this.staging}/cart`);
				} catch (error) {
					console.log('Error when applying voucher ', error);
				}
			});

			if (applyButton.classList.contains('btn-loading')) {
				applyButton.classList.remove('btn-loading');
			}
		}
	}

	handleApplyVoucher(code, token) {
		const modal = document.querySelector('crocs-loyalty-modal');
		const applyButton = modal.querySelector('.code-panel-apply');
		const copyIcon = modal.querySelectorAll('.copy-button');

		this.handleApplyDiscountButton(applyButton, code);

		if (copyIcon) {
			copyIcon.forEach(icon => {
				icon.addEventListener('click', () => {
					icon.classList.add('copied');
		
					if (token) {
						navigator.clipboard.writeText(icon.getAttribute('data-value')).catch((err) => {
							console.error('Failed to copy text: ', err);
						});
					}
		
					setTimeout(() => {
						icon.classList.remove('copied');
					}, 1500);
				});
			})
		}
	}

	async getVouchers(cursor = null, action = 'next', queryParams = {}) {
		console.log('render voucher to collect');

		const defaultParams = {
			usageChannel: 'Online,At Store',
			sortBy: 'asc',
			pageSize: 12,
		};

		let params = {
			...defaultParams,
			...queryParams,
			cursor: cursor,
			action: action,
		};

		try {
			const response = await this.apiRequest(
				'POST',
				{},
				params,
				this.apiEndPoint.searchCampaigns,
        true
			);
      console.log('params', params);

			if (response.status === 200 && response.data) {
				const totalVouchers = response.data.pageInfo.total;
				const vouchers = response.data.data;

				this.pagination = response.data.pageInfo;

				const pageInfo = response.data.pageInfo;
				if (pageInfo.reachedBottom) {
					this.loadMoreBtn.classList.add('hidden');
				} else {
					this.loadMoreBtn.classList.remove('hidden');
				}

				return { totals: totalVouchers, vouchers: vouchers };
			} else {
				return { totals: 0, vouchers: [] };
			}
		} catch (error) {
			console.error('Error while fetching vouchers 2:', error);
      const errorCodes = error?.response?.data?.error_fields || [];
			if (errorCodes.includes(956)) {
				document.dispatchEvent(new CustomEvent('loyalty:session-expired'));
			}
			return { totals: 0, vouchers: [] };
		}
	}

	async fetchUserPoints() {
		try {
			const response = await this.apiRequest(
				'POST',
				{},
				{},
				this.apiEndPoint.myPoints
			);

			if (response?.status === 200) {
				localStorage.setItem("loyalty_last_verified_at", response?.data?.data?.last_verify_at);
				this.userData.wallet = response.data.data;

				return { success: true, error: '' };
			}
		} catch (error) {
      if (error?.response?.data?.error_fields.includes(956)) {
        document.dispatchEvent(new CustomEvent('loyalty:session-expired'));
        return;
      }
			return { success: false, error: error };
		}
	}

	async getInfo() {
		try {
			const response = await this.apiRequest(
				'POST',
				{},
				{},
				this.apiEndPoint.myProfile
			);

			if (response?.status === 200) {
				localStorage.setItem("loyalty_last_verified_at", response?.data?.data?.last_verify_at);
				this.userData.profile = response.data.data;
				return { success: true, error: '' };
			}
		} catch (error) {
      if (error?.response?.data?.error_fields.includes(956)) {
        document.dispatchEvent(new CustomEvent('loyalty:session-expired'));
        return;
      }
			return { success: false, error: error };
		}
	}

	async filterVouchers(params) {
		try {
			const { totals, vouchers } = await this.getVouchers(null, 'next', { ...params, firstPage: true });

			this.updateVoucherListingTotals(totals, vouchers.length);

			this.currentListVoucher = vouchers;

			if (vouchers.length > 0) {
				this.clearVouchers(this.config.selectors.vouchersListing);
				this.appendNewVouchers(vouchers);
				const voucherItems =
					document.querySelectorAll('.voucher-card-item');
				vouchers.forEach((voucher, index) => {
					if (voucher.status !== 'active') {
						voucherItems[index].classList.add('inactive');
					}
				});
			} else {
				this.renderNoResultsMessage();
			}
			this.updatePaginationButtons();
		} catch (error) {
			console.error(error);
		} finally {
			this.spinner.hide();
		}
	}

	async getVerifiedState() {
		const lastVerifiedAt = localStorage.getItem("loyalty_last_verified_at");
		if (lastVerifiedAt) {
			const verifiedDate = new Date(lastVerifiedAt);
			if (verifiedDate.getTime() > new Date().getTime() - 30 * 60 * 1000) {
				return true;
			}
		}

		const localLoyaltyElement =
			document.querySelector('main-account[data-verified-at]') ||
			document.querySelector('account-vouchers[data-verified-at]');
		
		if (localLoyaltyElement) {
			const lastVerifiedAt = localLoyaltyElement.getAttribute('data-verified-at');
			if (lastVerifiedAt) {
				const verifiedDate = new Date(lastVerifiedAt);
				if (verifiedDate.getTime() > new Date().getTime() - 30 * 60 * 1000) {
					return true;
				}
			}
		}

		try {
			const response = await fetch(window.location.origin + window.location.pathname);
			const htmlText = await response.text();

			const parser = new DOMParser();
			const html = parser.parseFromString(htmlText, 'text/html');
			const loyaltyElement =
				html.querySelector('main-account[data-verified-at]') ||
				html.querySelector('account-vouchers[data-verified-at]');
			if (loyaltyElement) {
				const lastVerifiedAt =
					loyaltyElement.getAttribute('data-verified-at');
				const verifiedDate = new Date(lastVerifiedAt);
				if (
					verifiedDate.getTime() >
					new Date().getTime() - 30 * 60 * 1000
				) {
					return true;
				}
			}
		} catch (error) {
			console.error('Error fetching verified state:', error);
		}

		return false;
	}

	axiosWithCached(method, url, data, useCache = true) {
		if (method !== 'GET') {
			useCache = false;
		}
		const cacheKey = `${method}:${url}:${JSON.stringify(data)}`;

		if (window.fetchCaches === undefined) {
			window.fetchCaches = {};
		}

		if (window.ongoingFetches === undefined) {
			window.ongoingFetches = {};
		}

		if (useCache) {
			if (window.fetchCaches[cacheKey]) {
				return Promise.resolve(window.fetchCaches[cacheKey]);
			}
			
			const sessionCache = sessionStorage.getItem(cacheKey);
			if (sessionCache) {
				try {
					const cachedData = JSON.parse(sessionCache);
					window.fetchCaches[cacheKey] = cachedData;
					return Promise.resolve(cachedData);
				} catch (e) {
					console.warn('Invalid session cache', e);
				}
			}
		}

		if (window.ongoingFetches[cacheKey]) {
			return window.ongoingFetches[cacheKey];
		}

		const fetchPromise = axios({
			method,
			url,
			data,
			headers: {
				'Content-Type': 'application/json',
				'X-User-Token': this.config.userToken,
			},
		})
			.then((responseData) => {
				if (useCache) {
					// Store minimal data to save space, assuming we need data and status
					const cacheValue = {
						data: responseData.data,
						status: responseData.status,
						statusText: responseData.statusText
					};
					window.fetchCaches[cacheKey] = cacheValue;
					try {
						sessionStorage.setItem(cacheKey, JSON.stringify(cacheValue));
					} catch(e) {
						console.warn('Session storage full or unavailable', e);
					}
					return cacheValue;
				}
				delete window.ongoingFetches[cacheKey];
				return responseData;
			})
			.catch((error) => {
				delete window.ongoingFetches[cacheKey];
				throw error;
			});

		window.ongoingFetches[cacheKey] = fetchPromise;
		return fetchPromise;
	}

	showError(codes, element, remainingMessage = '') {
		const errorList = element?.querySelector('.field-errors');
		if (errorList) {
			errorList.innerHTML = '';
			codes.forEach((code) => {
				const errors = this.message.errorNumber();

				let message = '';
				if (errors[code]) {
					message =
						errors[code].message ||
						`Lỗi không xác định`;
				}

				const errorItem = document.createElement('li');
				errorItem.innerHTML = `<div data-reach-alert="true">${message}${remainingMessage}</div>`;
				errorList.appendChild(errorItem);
			});
			element.classList.add('active');
		}
	}

	async apiRequest(
		method,
		body = {},
		params = {},
		endpoint,
		forceRefresh = false
	) {
		try {
			const baseUrl = this.provider.hostName;
			const finalUrl = baseUrl.endsWith('/') ? baseUrl + endpoint.substring(1) : baseUrl + endpoint;
			const url = new URL(finalUrl);

			Object.keys(params).forEach((key) => {
				url.searchParams.append(key, params[key]);
			});

			const useCache = method === 'GET' && !forceRefresh;
			// console.log(`Antigravity: apiRequest [${method}] ${url.toString()} (cache: ${useCache})`);
			
			const response = await this.axiosWithCached(
				method,
				url.toString(),
				body,
				useCache
			);

			return response;
		} catch (error) {
			const errorCodes = error?.response?.data?.error_fields || [];
			if (errorCodes.includes(956)) {
				document.dispatchEvent(new CustomEvent('loyalty:session-expired'));
        return;
			}

			const ta = error?.response?.headers?.ta;
			const remainingAttempts = parseInt(ta) || '';
			let remainingMessage = '';

			if (remainingAttempts < 3 && remainingAttempts !== '') {
				remainingMessage = `. Bạn còn ${remainingAttempts} lần thử.`;
			}

			const errors = this.message.errorNumber();
			const errorCode = errors.hasOwnProperty(
				error?.response?.data?.error_fields[0]
			)
				? error?.response?.data?.error_fields[0]
				: error?.response?.data?.error_code;

			const errorMessage =
				errors[errorCode]?.message ||
				`Lỗi không mong muốn`;

			const codes = error?.response?.data?.error_fields || 400;
			const errorElement = document.querySelector(
				'#loyalty-modal-content .label-parent'
			);

			console.log(errorCode);
			console.log(errorMessage);

			if (errorCode) {
				this.showError(codes, errorElement, remainingMessage);
			}

			throw { code: errorCode, message: errorMessage, error: error };
		}
	}
}
customElements.define('account-vouchers', AccountVouchers);
